import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useCallback,
} from "react";
import { useHistory, useLocation, } from "react-router-dom";
import ReactToPrint from "react-to-print";
import html2canvas from "html2canvas";
import { Formik } from "formik";
import Swal from "sweetalert2";
import * as _ from "lodash";
import axios from "axios";
import { io } from "socket.io-client";
import "./index.css";
import { NumericFormat } from "react-number-format";
import ReactAudioPlayer from "react-audio-player";
import { toast } from "react-toastify";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  addCustomerList,
  setNewCustomer,
} from "../../redux/reducers/customerReducer";
import { addBankList } from "../../redux/reducers/bankReducer";

// components
import BillForCheckOut58 from "../../components/bill/BillForCheckOut58";
import BillForCheckOut80 from "../../components/bill/BillForCheckOut80";
import BillOfferPrice from "../../components/bill/BillOfferPrice";
import { errorSwal, requiredSwal, successSwal } from "../../helper/sweetalert";
import { base64ToBlob, convertCurrency, convertImageToBase64, calculateVat } from "../../helper";
import CustomButton from "../../components/CustomButton";
import { LaoAddress } from "../../const/laoAddress";
import CalculatorModal from "./CalculatorModal";
import { numberFormat } from "../../helper";
import { APP_COLOR, COLOR_WHITE, COLOR_WHITE_200, LINEAR_GRADIENT_BG, S3_URL, USER_KEY, KEY, PAYMENT_GATEWAY_API_URL, SHOP_SETTING_KEY, PRINT_ORDER, COLOR_APP } from "../../const";

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_MANY_ORDER_WITH_ORDER_GROUP,
  CREATE_MANY_PENDING_ORDER_WITH_ORDER_GROUP,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_NOT_YET_PAID,
  UPDATE_MANY_PENDING_ORDER_GROUP,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_V2,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED_V2,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_V3,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED_V3,
  CREATE_MANY_ORDER_WITH_ORDER_GROUP_V4

} from "../../apollo/order/mutation";
import {
  SALE_OFFER_PRICE,
} from "../../apollo/offerpricegroup/mutation";
import { CREATE_USER_CONFIRM } from "../../apollo/userconfirm/mutation";
import { GET_USER_CONFIRM } from "../../apollo/userconfirm/query";
import { GET_BANKS } from "../../apollo/bank/query";
import BillForCheckOutA4V2 from "../../components/bill/BillForCheckOutA4V2";
import BillForCheckOutA4V3 from "../../components/bill/BillForCheckOutA4V3";
import { GET_REWARDS_V2 } from "../../apollo/reward/Query";
import { GET_USER_CONFIRM_ONE } from "../../apollo/userconfirm/query";
import { QRCode } from "react-qrcode-logo";


// icon
import Add from "@mui/icons-material/Add";
import Close from "@mui/icons-material/Close";
import CloseIcon from "@mui/icons-material/Close";
import { FaCartArrowDown, FaCheck, FaCheckCircle } from "react-icons/fa";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QrCode2Icon from "@mui/icons-material/QrCode2";

// bootrap
import {
  Row,
  Col,
  Modal,
  Table,
  Spinner,
  Button,
  DropdownButton, Dropdown,
  Form, Tab, Tabs
} from "react-bootstrap";
import { UPDATE_ORDER_GROUP_V2 } from "../../apollo/ordergroup/mutation";
import EmptyComponent from "../../components/EmptyComponent";
import BillIndebTed from "../../components/bill/BillIndebTed";
import AnimationLoading from "../../components/Animationloading";
import EmptyProducts from "../../components/EmptyProducts";
import { GET_EXCHANGE_RATE, SCAN_PRODUCT } from "../../apollo/product/query";
import ComfirmModal from "../../components/ComfirmModal";
import { GET_USER_TYPE } from "../../apollo/userType/mutation";
import useWindowDimensions from "../../helper/windowDimensions";
import { ReactIcons } from "../../icons";
import { useTranslation } from "react-i18next";
import { normalizeLanguageCode } from "../../helper/i18n";
import { languageTypes } from "../setting/LanguageSetting";
import SettingCmScreen from "../customerDesktop/SettingCmScreen";
import PlusOptionModal from "./PlusOptionModal";
import WaitingPaymentModal from "../../components/WaitingPaymentModal";

function Carts({
  containerRef,
  products,
  setProducts,
  selectedPayCurrency,
  setSelectedPayCurrency,
  originProducts,
  setOriginProducts,
  cartDatas,
  setCartDatas,
  activeCart,
  setActiveCart,
  updateOrder,
  onClearOrder,
  fetchProductData,
  printer,
  gencodeordergroup,
  _loadGenCode,
  saleEditdata,
  addOrder,
  shopData,
  setIsMobileCart,
  serviceOther,
  setServiceOther,
  settingObject,
  promotionData
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const Location = useLocation();
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const staffname = JSON.parse(localStorage.getItem(USER_KEY));
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
  


  const soundPlayer = useRef();
  let componentRef = useRef();
  let billIndebTedRef = useRef();
  const { height, width } = useWindowDimensions()
  const { t, i18n } = useTranslation();
  const commissionEnable = shopSetting?.commissionEnable ?? false;
  const [languageName, setLanguageName] = useState();
  const channelTypes = [
    { value: "POS", name: "ໜ້າຮ້ານ" },
    { value: "ONLINE", name: "ອອນໄລນ໌" },
  ];
  const [channelName, setChannelName] = useState("POS");
  const [showSalePageQr, setShowSalePageQr] = useState(false);
  const [copiedSalePageLink, setCopiedSalePageLink] = useState(false);

  //data for redux
  const { customerList } = useSelector((state) => state.customer);
  const { bankList } = useSelector((state) => state.bank);

  const [showAddcustommer, setShowAddCustommer] = useState(false);
  const [showaddcustomerIndebTed, setShowAddCustomerIndebTed] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [customername, setCustommerName] = useState();
  const [customerLastName, setCustommerLastName] = useState();
  const [phonenumber, setPhoneNumber] = useState();
  const [village, setVillage] = useState();
  const [district, setDistrict] = useState();
  const [province, setProvince] = useState();
  const [userconfirmName, setUserConfirmName] = useState();
  const [userconfirmPhone, setUserConfirmPhone] = useState();
  const [showSelectCustomer, setShowSelectCusTomer] = useState(false);
  const [showAddCustomerBill, setShowAddCusTomerBill] = useState(false);
  const [userconfirm, setUserConfirm] = useState();
  const [selectuserconfirm, setSelectUserConfirm] = useState();
  const [userconfirmId, setUserConfirmId] = useState();
  const [showAddress, setShowAdddress] = useState(false);
  const [phonenumberAdd, setPhoneNumberAdd] = useState();
  const [selectProvince, setSelectProvince] = useState();
  const [selectDistrict, setSelectDistrict] = useState();
  const [selectvillage, setSelectVillage] = useState();
  const [bankaccount, setBankAccount] = useState();

  const [showUnitModal, setShowUnitModal] = useState(false);
  const [unitModalContext, setUnitModalContext] = useState(null);
  const [selectedUnitName, setSelectedUnitName] = useState("");
  const unitOptions = React.useMemo(() => {
    const setUnits = new Set();
    (originProducts || []).forEach((p) => {
      const name = (p?.unitId?.name ?? p?.unit ?? "").toString().trim();
      if (name) setUnits.add(name);
    });
    return Array.from(setUnits).sort((a, b) => a.localeCompare(b));
  }, [originProducts]);
  const handleOpenUnitModal = () => setShowUnitModal(true);
  const handleSelectUnit = (unitName) => {
    setSelectedUnitName(unitName);
  };
  const handleClearUnitFilter = () => {
    setSelectedUnitName("");
  };
  const unitFilteredProducts = React.useMemo(() => {
    if (!selectedUnitName) return [];
    const key = selectedUnitName.toString().trim().toLowerCase();
    return (originProducts || []).filter(
      (p) => ((p?.unitId?.name ?? p?.unit ?? "").toString().trim().toLowerCase() === key)
    );
  }, [originProducts, selectedUnitName]);
  const handleAddFreeChild = (productItem) => {
    if (!unitModalContext) return;
    const { cartIndex, orderIndex } = unitModalContext;
    setCartDatas((prev) => {
      const newCartData = JSON.parse(JSON.stringify(prev));
      if (!newCartData[cartIndex]) return prev;
      const order = newCartData[cartIndex]?.data?.orders?.[orderIndex];
      if (!order) return prev;
      if (!order.children) order.children = [];
      order.children.push({
        product: productItem?.id,
        stock: productItem?.stock ?? productItem?.id,
        productName: productItem?.name,
        amount: 1,
        price: 0,
        tag: "FREE",
        saleTag: "FREE",
      });
      // Recalculate cart totals
      let orderAmount = 0;
      let childrenAmount = 0;
      let orderVolume = 0;
      let childrenVolume = 0;
      newCartData[cartIndex].data.orders = newCartData[cartIndex].data.orders.map((order) => {
        const amountChild = (order.children || []).reduce((sum, c) => sum + parseInt(c?.amount || 0, 10), 0);
        const volumeChild = (order.children || []).reduce((sum, c) => sum + parseInt(c?.volume || 0, 10), 0);
        orderAmount += parseInt(order?.amount || 0, 10);
        orderVolume += parseInt(order?.volume || 0, 10);
        childrenAmount += amountChild;
        childrenVolume += volumeChild;
        const orderTotal = parseInt(order?.price || 0, 10) * parseInt(order?.amount || 0, 10);
        const childrenTotal = (order.children || []).reduce((sum, c) => {
          if (c.saleTag === "VOLUME") {
            return sum + parseInt(c?.totalPrice || 0, 10);
          } else {
            return sum + parseInt(c?.price || 0, 10) * parseInt(c?.amount || 0, 10);
          }
        }, 0);
        return {
          ...order,
          amountChild,
          volumeChild,
          total: orderTotal,
          totalPrice: orderTotal + childrenTotal
        };
      });
      if (newCartData[cartIndex].data.orderGroup) {
        newCartData[cartIndex].data.orderGroup.amount = orderAmount + childrenAmount;
        newCartData[cartIndex].data.orderGroup.volume = orderVolume + childrenVolume;
      }
      return newCartData;
    });
    setShowUnitModal(false);
    setSelectedUnitName("");
    setUnitModalContext(null);
  };
  const [showDetailSaleModal, setShowDetailSaleModal] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPricePay, setTotalPricePay] = useState(0);
  const [currentPoint, setCurrentPoint] = useState(0)
  const [change, setChange] = useState(0);
  const [receivedMoney, setReceivedMoney] = useState(0);
  const [activeTab, setActiveTab] = useState("CASH");
  const [offerPrice, setOffePrice] = useState();
  const [selectedPrice, setSelectedPrice] = useState();
  const [widthBill80, setWidthBill80] = useState(0);
  const [widthBill58, setWidthBill58] = useState(0);
  const [notYetPaid, setNotYetPaid] = useState(false);
  const [searchcustomer, setSearchCustomer] = useState("");
  const [isSearch, setIsSearch] = useState("");
  const [editdata, setEditdata] = useState(Location.state);
  const [codeBill, setCodeBill] = useState(null);
  const [isFreeStatus, setIsFreeSatus] = useState({
    isOpen: false,
    preOrder: null,
    amountFree: 0,
    cartIndex: null,
  })

  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const [openEditPrice, setOpenEditPrice] = useState(false);
  const [prepareRate, setPrepareRate] = useState();

  const [newUserTypeData, setNewUserTypeData] = useState();
  const [selectUserType, setSelectUserType] = useState("");
  const [addUserType, setAddUserType] = useState("");
  const [base64Image, setBase64Image] = useState()
  const [isCustomerScreen, setIsCustomerScreen] = useState({
    isOpen: false,
    data: null,
  });

  const [loadingPrintBill, setLoadingPrintBill] = useState(false);
  const [previewingA4, setPreviewingA4] = useState(false);
  const [loadingSaleBill, setLoadingSaleBill] = useState(false);
  const [isBillNumber, setIsBillNumber] = useState(false);
  const [shopDataNow, setShopDataNow] = useState()
  const [paymentDate, setPaymentDate] = useState();
  const currentShopIdForA4 = shopDataNow?.id || shopDataNow?.shop?.id || JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const isA4V3Shop = currentShopIdForA4 === "63ec6d38c617221e6ccf5edc";
  // for payment
  const [paymentQR, setPaymentQR] = useState(null);
  const [paymetCallbackData, setPaymetCallbackData] = useState(null);
  const [isNeededBill, setisNeededBill] = useState(false);
  const [isBillPrinting, setIsBillPrinting] = useState(false);
  const [viewCurrency, setViewCurrency] = useState()
  //TODO: Plus Stock State
  const [showPlusStockModal, setShowPlusStockModal] = useState(false);
  const [plusStock, setPlusStock] = useState({
    order: {}, oIndex: 0, cart: {}, cIndex: 0
  });
  const salePageUrl = `https://salepage.packxi.shop/shop/${shopId ?? ""}`;

  const handleCopySalePageLink = async () => {
    try {
      if (!shopId) {
        return errorSwal("ບໍ່ພົບຮ້ານ ກະລຸນາກວດສອບຂໍ້ມູນຮ້ານ");
      }
      await navigator.clipboard.writeText(salePageUrl);
      setCopiedSalePageLink(true);
      setTimeout(() => {
        setCopiedSalePageLink(false);
      }, 2000);
      successSwal("ຄັດລອກລິ້ງເຊລເພຈສຳເລັດ!");
    } catch (err) {
      errorSwal("ຄັດລອກລິ້ງບໍ່ສຳເລັດ");
    }
  };

  const handleGenerateQr = () => {
    if (!shopId) {
      return errorSwal("ບໍ່ພົບຮ້ານ ກະລຸນາກວດສອບຂໍ້ມູນຮ້ານ");
    }
    setShowSalePageQr(true);
  };
  
  const handleDownloadQr = () => {
    try {
      const canvas = document.querySelector('#salepage-qr');
      if (!canvas) {
        return errorSwal("ບໍ່ພົບ QR ສຳລັບດາວໂຫລດ");
      }
      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = `shop-${shopId}-qr.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      errorSwal("ດາວໂຫລດ QR ບໍ່ສຳເລັດ");
    }
  };

  const handlePlusStock = async (order, oIndex, cart, cIndex) => {
    try {
      setPlusStock({ order, oIndex, cart, cIndex }); // plus for stock
      setShowPlusStockModal(true); // open modal plus stock
    } catch (error) {
      console.log("error handlePlusStock: ", error);
      return;
    }
  };
  

  const handleUpdateChildAmount = (childrenIndex, oIndex, cIndex, value) => {
    try {
      const parsedValue = parseInt(value, 10);
      const safeValue = Number.isNaN(parsedValue) ? 0 : parsedValue;
      if (safeValue < 0) {
        errorSwal('ຈຳນວນສີນຄ້າຕ້ອງ ຫລາຍກ່ອນ 0 ເດີ້');
        return;
      }
      let newCartData = JSON.parse(JSON.stringify(cartDatas));
      if (!newCartData[cIndex] ||
        !newCartData[cIndex].data?.orders ||
        !newCartData[cIndex].data.orders[oIndex] ||
        !newCartData[cIndex].data.orders[oIndex].children) {
        console.error("Invalid indices or structure not found in cartDatas");
        return;
      }
      if (!newCartData[cIndex].data.orders[oIndex].children[childrenIndex]) return;
      newCartData[cIndex].data.orders[oIndex].children[childrenIndex] = {
        ...newCartData[cIndex].data.orders[oIndex].children[childrenIndex],
        amount: safeValue,
        price: 0,
        totalPrice: 0,
      };
      let orderAmount = 0;
      let childrenAmount = 0;
      let orderVolume = 0;
      let childrenVolume = 0;
      newCartData[cIndex].data.orders = newCartData[cIndex].data.orders.map((order) => {
        const amountChild = (order.children || [])
          .reduce((sum, c) => sum + parseInt(c?.amount || 0, 10), 0);
        const volumeChild = (order.children || [])
          .reduce((sum, c) => sum + parseInt(c?.volume || 0, 10), 0);
        orderAmount += parseInt(order?.amount || 0, 10);
        orderVolume += parseInt(order?.volume || 0, 10);
        childrenAmount += amountChild;
        childrenVolume += volumeChild;
        const orderTotal = parseInt(order?.price || 0, 10) * parseInt(order?.amount || 0, 10);
        const childrenTotal = (order.children || []).reduce((sum, c) => {
          if (c.saleTag === "VOLUME") {
            return sum + parseInt(c?.totalPrice || 0, 10);
          } else {
            return sum + parseInt(c?.price || 0, 10) * parseInt(c?.amount || 0, 10);
          }
        }, 0);
        return {
          ...order,
          amountChild,
          volumeChild,
          total: orderTotal,
          totalPrice: orderTotal + childrenTotal
        };
      });
      if (newCartData[cIndex].data.orderGroup) {
        newCartData[cIndex].data.orderGroup.amount = orderAmount + childrenAmount;
        newCartData[cIndex].data.orderGroup.volume = orderVolume + childrenVolume;
      }
      setCartDatas(newCartData);
    } catch (error) {
      console.error("Error in handleUpdateChildAmount:", error);
    }
  };

  const handleRemoveStockChildren = async (childrenIndex, oIndex, cIndex) => {
    try {
      let newCartData = JSON.parse(JSON.stringify(cartDatas));
      if (!newCartData[cIndex] ||
        !newCartData[cIndex].data?.orders ||
        !newCartData[cIndex].data.orders[oIndex] ||
        !newCartData[cIndex].data.orders[oIndex].children) {
        console.error("Invalid indices or structure not found in cartDatas");
        return;
      }
      newCartData[cIndex].data.orders[oIndex].children.splice(childrenIndex, 1);
      let orderAmount = 0;
      let childrenAmount = 0;
      let orderVolume = 0;
      let childrenVolume = 0;
      newCartData[cIndex].data.orders = newCartData[cIndex].data.orders.map((order) => {
        const amountChild = (order.children || [])
          .reduce((sum, c) => sum + parseInt(c?.amount || 0, 10), 0);
        const volumeChild = (order.children || [])
          .reduce((sum, c) => sum + parseInt(c?.volume || 0, 10), 0);
        orderAmount += parseInt(order?.amount || 0, 10);
        orderVolume += parseInt(order?.volume || 0, 10);
        childrenAmount += amountChild;
        childrenVolume += volumeChild;
        const orderTotal = parseInt(order?.price || 0, 10) * parseInt(order?.amount || 0, 10);
        const childrenTotal = (order.children || []).reduce((sum, c) => {
          if (c.saleTag === "VOLUME") {
            return sum + parseInt(c?.totalPrice || 0, 10);
          } else {
            return sum + parseInt(c?.price || 0, 10) * parseInt(c?.amount || 0, 10);
          }
        }, 0);
        return {
          ...order,
          amountChild,
          volumeChild,
          total: orderTotal,
          totalPrice: orderTotal + childrenTotal
        };
      });
      if (newCartData[cIndex].data.orderGroup) {
        newCartData[cIndex].data.orderGroup.amount = orderAmount + childrenAmount;
        newCartData[cIndex].data.orderGroup.volume = orderVolume + childrenVolume;
      }
      setCartDatas(newCartData);
    } catch (error) {
      console.error("Error in handleRemoveStockChildren:", error);
    }
  };

  const handleShowConfirmProduct = () => {
    setShowConfirmRemove(true);
  };

  const handleCloseRemoveProduct = () => {
    setShowConfirmRemove(false);
    setOpenEditPrice(false);
  };

  const handleConfirmRemoveCart = () => {
    setShowConfirmRemove(false);
    setOpenEditPrice(true);
  };


  const [getuserConfirm, { data: getuserConfirmData, loading: userconfirmLoading }] = useLazyQuery(
    GET_USER_CONFIRM,
    { fetchPolicy: "cache-and-network" }
  );

  const [getBank, { data: getbankData, loading: bankloadding }] = useLazyQuery(
    GET_BANKS,
    { fetchPolicy: "cache-and-network" }
  );
  const [getProductFromBarcode] = useLazyQuery(SCAN_PRODUCT);
  const [userTypeData, { data: getUserTypeData, loading: getUserTypeLoading }] =
    useLazyQuery(GET_USER_TYPE, { fetchPolicy: "cache-first" });

 
  const [createManyOrderWithOrderGroupV4, { loading: createOrderLoadingV4 }] =
    useMutation(CREATE_MANY_ORDER_WITH_ORDER_GROUP_V4); 
  const [createManyPendingOrderWithOrderGroup, { loading: createPendingOrderLoading }] =
    useMutation(CREATE_MANY_PENDING_ORDER_WITH_ORDER_GROUP);

  const [
    createManyOrderWithOrderGroupNotYetPaid,
    { loading: createOrderNotYetPaidLoading },
  ] = useMutation(CREATE_MANY_ORDER_WITH_ORDER_GROUP_NOT_YET_PAID);

  // const [
  //   createManyOrderWithOrderGroupIndebTedV2,
  //   { loading: createOrderIndebTedLoading },
  // ] = useMutation(CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED_V2);
  const [
    createManyOrderWithOrderGroupIndebTedV3,
    { loading: createOrderIndebTedLoading },
  ] = useMutation(CREATE_MANY_ORDER_WITH_ORDER_GROUP_INDEBTED_V3);

  //TODO
  const [updateOrderGroupV2, { loading: orderGroupV2Loading }] =
    useMutation(UPDATE_ORDER_GROUP_V2);
  const [createUserConfirm, { loading: loadingCreate }] =
    useMutation(CREATE_USER_CONFIRM);
  const [saleOfferPrice, { loading: saleOfferPriceLoading }] =
    useMutation(SALE_OFFER_PRICE);

  const [updateManyPendingOrderGroup,
    { loading: updatePendingOrderGroupLoading },
  ] = useMutation(UPDATE_MANY_PENDING_ORDER_GROUP);
  const [
    getExchangeRate,
    { data: exchangeRateData },
  ] = useLazyQuery(GET_EXCHANGE_RATE, {
    fetchPolicy: "cache-and-network",
  });

  // ---------------------------------------ueseEffect--------------------------------------------------
  useEffect(() => {
    const socket = io(`${PAYMENT_GATEWAY_API_URL}`, {
      transports: ["websocket"],
    });
    function onConnect() {
      console.log("CONNECTED");
    }
    function onDisconnect() {
      console.log("DISCONNECTED");
    }
    function onSubscriptionPayment(value) {
      // console.log("logs sub value: ", value)
      if (value?.transactionId === paymentQR?.transactionId && value?.status === "PAYMENT_COMPLETED" && value?.tag1 === shopData?.shop?.id) {
        setPaymetCallbackData(value);
        setPaymentQR(null);
        localStorage.removeItem("PAYMENT_QR_DATA");
        successSwal("ຊຳລະເງິນສຳເລັດ");
        handlePlayer() // play the sound success
        if (!isNeededBill && shopData?.shop?.isPaymentGateway) {
          handleClearCartDatas();
        }
      }
    }
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on(
      `join::${KEY}`,
      onSubscriptionPayment
    );
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off(
        `join::${KEY}`,
        onSubscriptionPayment
      );
    };
  }, [paymentQR?.transactionId]);

  useEffect(() => {
    if (paymetCallbackData) {
      updateManyPendingOrderGroup(
        {
          variables: {
            where: {
              "id": paymetCallbackData?.tag3, // tag3 is orderGroupId
              // "message": null
            },
          },
        }
      ).then((res) => {
        if (isNeededBill) {
          onPrintBill();
        }
        setPaymetCallbackData(null);
      });
    }
  }, [paymetCallbackData])


  useEffect(() => {
    if (customerList?.length === 0) {
      getuserConfirm({
        variables: {
          // limit: 500,
          where: {
            shop: shopId,
            isDeleted: false,
            orderBy: "createdAt_DESC",
          },
        },
      });
    }

    if (bankList?.length === 0) {
      getBank({
        variables: {
          // limit: 50,
          orderBy: "createdAt_DESC",
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    }



  }, [shopId]);

  useEffect(() => {

    _filter();
  }, [searchcustomer]);

  useEffect(() => {

    if (shopData) {
      setShopDataNow(shopData?.shop);
      setIsBillNumber(shopData?.shop?.isBillNumber);

      const _getImage = S3_URL + shopData?.shop?.image;

      convertImageToBase64(_getImage).then((base64) => {
        setBase64Image(base64);
      });
    }


  }, [shopData]);


  useEffect(() => {

    if (exchangeRateData) {
      setPrepareRate(exchangeRateData?.exchangeRate)
      localStorage.setItem("RATE_BY_SHOP", JSON.stringify({ datas: exchangeRateData?.exchangeRate }));

    }

  }, [exchangeRateData])

  useEffect(() => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    getExchangeRate({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  }, []);

  useEffect(() => {

    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);

    if (!selectedCart) return;
    setTotalAmount(selectedCart?.data?.orderGroup?.amount ?? 0);
    setTotalPricePay(selectedCart?.data?.orderGroup?.sumPrice ?? 0);

    // emit data to socket
    if (!editdata?.isEdited) {
      const commissionChannel =
        selectedCart?.data?.orderGroup?.commissionPlatforms ||
        selectedCart?.data?.orderGroup?.channel ||
        channelName;
      const commissionPlatform = getCommissionPlatformFromOrders(
        selectedCart?.data?.orders,
        commissionChannel,
      );
      const commissionData = commissionPlatform
        ? { commissionPlatforms: commissionPlatform }
        : {};
      const cartWithCommission = {
        ...selectedCart,
        data: {
          ...selectedCart?.data,
          orderGroup: {
            ...selectedCart?.data?.orderGroup,
            ...commissionData,
          },
        },
      };
      localStorage.setItem(
        "CART_DATAS",
        JSON.stringify({ datas: cartWithCommission }),
      );
      setViewCurrency(selectedCart?.data?.orderGroup?.currency)
    }

  }, [activeCart, cartDatas, channelName]);

  useEffect(() => {
    if (editdata?.isEdited) return;
    setCartDatas((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      const paid = parseFloat(receivedMoney || 0) || 0;
      return prev.map((cart) => {
        if (cart.label !== activeCart) return cart;
        const orderGroup = cart?.data?.orderGroup || {};
        const sum = parseFloat(orderGroup?.sumPrice || 0) || 0;
        return {
          ...cart,
          data: {
            ...cart.data,
            orderGroup: {
              ...orderGroup,
              receivedMoney: paid,
              change: paid - sum,
            },
          },
        };
      });
    });
  }, [receivedMoney, activeCart, editdata?.isEdited]);

  useEffect(() => {
    if (editdata?.isEdited) {
      setCustommerName(editdata?.state?.customerName);
      setPhoneNumber(editdata?.state?.phone);
      setReceivedMoney(editdata?.state?.receivedMoney || 0);
    }
  }, [editdata?.isEdited]);

  useEffect(() => {
    if (getbankData?.banks?.data) {
      dispatch(addBankList(getbankData?.banks?.data));
      setBankAccount(getbankData?.banks?.data)
    }

    if (getuserConfirmData?.userconfirms?.data) {
      dispatch(addCustomerList(getuserConfirmData?.userconfirms?.data));
    }
  }, [getbankData?.banks?.data, getuserConfirmData?.userconfirms?.data]);

  useEffect(() => {

    if (selectedPrice !== "ALL") changeAllPrice();
  }, [selectedPrice]);

  useEffect(() => {
    if (selectuserconfirm) {
      setCustomerId(selectuserconfirm?.id);
      setCustommerName(selectuserconfirm?.name);
      setCustommerLastName(selectuserconfirm?.lastname);
      setPhoneNumber(selectuserconfirm?.phone);
      setUserConfirmId(selectuserconfirm?.id);
      setVillage(selectuserconfirm?.address?.village);
      setDistrict(selectuserconfirm?.address?.district);
      setProvince(selectuserconfirm?.address?.province);
      setCurrentPoint(selectuserconfirm?.currentPoint);
    }
  }, [selectuserconfirm]);

  // Update currentPoint when getuserConfirmData changes (after refetch)
  useEffect(() => {
    if (userconfirmId && getuserConfirmData?.userconfirms?.data) {
      const updatedUserConfirm = getuserConfirmData.userconfirms.data.find(
        (user) => user.id === userconfirmId
      );
      if (updatedUserConfirm) {
        setCurrentPoint(updatedUserConfirm.currentPoint);
      }
    }
  }, [getuserConfirmData, userconfirmId]);

  useEffect(() => {

    userTypeData();
  }, [showSelectCustomer]);

  useEffect(() => {

    if (getUserTypeData?.getUserTypes) {
      const data = getUserTypeData?.getUserTypes.filter((item) => item?.isOpen);
      setNewUserTypeData(data);
    }
  }, [getUserTypeData?.getUserTypes]);

  // ==========> Fuction <==========

  const handleSelect = (label) => {
    setActiveCart(label);
  };


  // clear cart function -------->
  const handleClearCartDatas = () => {
    fetchProductData();
    setShowDetailSaleModal(false);
    handleRemoveCart({ label: activeCart, isRemove: true });
    handleClearServiceOther();
    setActiveTab("CASH");
    setChange(0);
    setReceivedMoney("0");
    setCustommerName();
    setPhoneNumber();
    setCustommerLastName();
    setVillage();
    setDistrict();
    setSelectUserConfirm();
    setProvince();
    setIsMobileCart(false);
    setCodeBill(null);

    setLoadingPrintBill(false);
    setLoadingSaleBill(false);
  };

  // remove active cart data by activeCart
  const handleClearServiceOther = () => {
    const updatedServiceOther = serviceOther.filter((cart) => cart?.activeCart !== activeCart);
    setServiceOther(updatedServiceOther);
  };

  const handleOpentOfferprice = () => {
    setShowAddCustomerIndebTed(true);
  };

  const handleOfferprices = () => {
    setShowAddCustommer(true);
    if (getuserConfirmData?.userconfirms?.data) {
      setUserConfirm(getuserConfirmData?.userconfirms?.data);
    }
  };

  const handleSaleModal = () => {
    setShowDetailSaleModal(true);
    _loadGenCode();
  };

  const _createUser = async (values) => {
    if (!values.name) {
      errorSwal("ກະລຸນາເພີ່ມຂໍ້ມູນ...");
      return;
    }
    if (_.isEmpty(values?.userType)) values = { ...values, userType: addUserType || newUserTypeData[0]?.id };
    try {
      if (loadingCreate) return;
      const createNewUser = await createUserConfirm({
        variables: {
          data: {
            ...values,
            phone: phonenumberAdd.toString(),
            address: {
              village: selectvillage,
              district: selectDistrict,
              province: selectProvince,
            },
          },
        },
      });

      if (createNewUser?.data?.createUserConfirm?.id !== null) {
        let data = createNewUser?.data?.createUserConfirm;
        console.log({ data });

        dispatch(
          setNewCustomer({
            id: data?.id,
            name: data?.name,
            lastname: data?.lastname,
            gender: data?.gender,
            phone: data?.phone,
            address: {
              village: data?.address?.village,
              district: data?.address?.district,
              province: data?.address?.province,
            },
            userType: data?.userType
          })
        );

        handleConfirmClose();
        successSwal("ເພີ່ມສຳເລັດ");
        setPhoneNumberAdd();
      }

      // _filter();
      // setShowAddUser(false)
      // setShowAddCusTomerBill(false);
      // successSwal("ເພີ່ມສຳເລັດ");
      // setPhoneNumberAdd();
    } catch (err) {
      errorSwal("ລາຍຊື່ລູກຄ້ານີ້ມີຢູ່ແລ້ວ");
    }
  };

  const handleAddCart = async () => {
    const shopId = (await JSON.parse(localStorage.getItem("SHOP_DATA")))?.id;

    if (cartDatas?.length >= 3) return;

    const lastCartId = cartDatas[cartDatas?.length - 1]?.id || 0;
    const number = parseInt(gencodeordergroup - 1) + lastCartId + 1;
    
    const newCart = {
      id: lastCartId + 1,
      label: `Bill ${lastCartId + 1}`,
      data: {
        orders: [],
        orderGroup: {
          amount: 0,
          totalPrice: 0,
          receivedMoney: 0,
          change: 0,
          sumPrice: 0,
          sumPriceBaht: 0,
          sumPriceUsd: 0,
          currency: "LAK",
          shop: shopId,
          payment: "CASH",
          discount: cartDatas[0]?.data?.orderGroup?.discount ?? 0,
          discountType: cartDatas[0]?.data?.orderGroup?.discountType ?? false,
          shippingCost: 0,
        },
      },
    };

    // setGetCartId(newCart?.id)cls

    if (!_.isEmpty(newCart)) {
      setCartDatas([...cartDatas, newCart]);
      setActiveCart(newCart?.label);
    }

  };

  // ລ້າງສິນຄ້າໃນກະຕ່າອອກ
  const handleRemoveCart = async ({ label, isRemove }) => {
    if (!isRemove) return;

    const shopId = (await JSON.parse(localStorage.getItem("SHOP_DATA")))?.id;

    // Find the bill to remove by its label
    const orderData = _.find(cartDatas, { label });
    if (!orderData) return;

    const { orders } = orderData?.data;

    // Update the origin products
    const updatedOriginData = originProducts.map((originProduct) => {
      const matchingData = orders.find((order) => order.product === originProduct.id);
      return matchingData
        ? {
          ...originProduct,
          amount: matchingData.amount + originProduct.amount,
        }
        : originProduct;
    });

    setOriginProducts(updatedOriginData);


    // If there's only one cart left, reset it with an empty "Bill 1"
    if (cartDatas?.length === 1) {
      setActiveCart("Bill 1");
      setCartDatas((preCart) => {
        return [
          {
            id: 1,
            label: "Bill 1",
            data: {
              orders: [],
              orderGroup: {
                amount: 0,
                totalPrice: 0,
                receivedMoney: 0,
                change: 0,
                sumPrice: 0,
                sumPriceBaht: 0,
                sumPriceUsd: 0,
                currency: "LAK",
                shop: shopId,
                payment: "CASH",
                shippingCost: 0,
                discount: promotionData?.status === "ACTIVED" ? cartDatas[0]?.data?.orderGroup?.discount || 0 : 0,
                discountType: promotionData?.status === "ACTIVED" ? cartDatas[0]?.data?.orderGroup?.discountType || false : false,
              },
            },
          },
        ]
      });
      return;
    }

    // Remove the selected cart
    const _newCartDatas = cartDatas.filter((cart) => cart.label !== label);

    // Update the active cart if the removed cart was the active one
    if (activeCart === label) {
      setActiveCart(_newCartDatas[0]?.label);
    } else {
      setActiveCart(activeCart);
    }

    if (!_.isEmpty(_newCartDatas)) {
      setCartDatas(_newCartDatas);
    }

  };

  const normalizeChildrenStockForPayload = (children) => {
    if (!Array.isArray(children)) return children;
    return children.map((child) => {
      const stockValue = child?.stock || child?._stock;
      if (!stockValue) return child;
      let stockId;
      if (typeof stockValue === "string") {
        stockId = stockValue;
      } else if (typeof stockValue === "object") {
        stockId = stockValue?.id || stockValue?._id || stockValue?.stock?.id;
      }
      if (!stockId) return child;
      return { ...child, stock: { id: stockId } };
    });
  };

  //TODO: ຕີດຫນີ້ຮັບບີນ || Bill USB
  const onCreateManyOrderWithOrderGroup = async (shouldPrintBill = false) => {
    try {
      if (createOrderLoadingV4) return;

      if (editdata?.isEdited) {
        return _saleOfferPrice();
      }

      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);

      if (!selectedCart) {
        return;
      }

      const { orders, orderGroup } = selectedCart?.data;
      const staffFirstName =
        staffname?.data?.firstName || staffname?.data?.nickname;

      let _updatedOfferPriceGroup = {
        ...orderGroup,
        shop: shopId,
        customerId: customerId,
        customerName: customername,
        customerLastName: customerLastName,
        village: village,
        district: district,
        province: province,
        phone: phonenumber,
        staff: staffFirstName,
        staffLastname: staffname?.data?.lastName,
        payment: activeTab ?? "CASH",
        change: parseFloat(change),
        currency: selectedPayCurrency,
        receivedMoney: parseFloat(receivedMoney),
        code: gencodeordergroup,
      };
      if (!_.isEmpty(customerId)) _updatedOfferPriceGroup = { ..._updatedOfferPriceGroup, userConfirm: customerId };

      const commissionChannel =
        _updatedOfferPriceGroup?.commissionPlatforms ||
        _updatedOfferPriceGroup?.commissionType ||
        _updatedOfferPriceGroup?.channel ||
        channelName ||
        "POS";
      
      // Create orders for backend (map to commissionPlatform/commissionValue)
      const updatedOfferprices = orders.map((order) => {
        const {
          totalAmount,
          brand,
          priceOptions,
          product,
          category,
          productVariant,
          stock,
          commissionPlatforms: _commissionPlatforms,
          commissionPlatform: _commissionPlatform,
          commissionType: _commissionType,
          commissionValue: _commissionValue,
          ...rest
        } = order;
        const commissionMatch = getCommissionMatchForOrder(order, commissionChannel);
        const normalizedChildren = normalizeChildrenStockForPayload(order?.children);
        return {
          ...rest,
          children: normalizedChildren,
          stock: stock ?? order?.product,
          productVariant: productVariant || undefined,
          commissionPlatform: commissionMatch?.platform || commissionChannel,
          commissionType: commissionMatch?.commissionType,
          commissionValue: commissionMatch?.commissionValue || 0,
        };
      });

    const rateBaht = parseFloat(prepareRate?.baht || 1) || 1;
    const rateUsd = parseFloat(prepareRate?.usd || 1) || 1;
    const commissionTotal = getCommissionTotalFromOrders(
      orders,
      commissionChannel,
      rateBaht,
      rateUsd,
    );
    const sums = (Array.isArray(updatedOfferprices) ? updatedOfferprices : []).reduce((acc, o) => {
      const price = (Number(o?.price || 0) * Number(o?.amount || 0));
      const cur = o?.currency;
      if (cur === "BAHT" || cur === "ບາດ") acc.baht += price;
      else if (cur === "USD" || cur === "ໂດລາ") acc.usd += price;
      else acc.lak += price;
      return acc;
    }, { lak: 0, baht: 0, usd: 0 });
    const rawShippingCost = Number(_updatedOfferPriceGroup?.shippingCost) || 0;
    let combined = sums.lak + (sums.baht * rateBaht) + (sums.usd * rateUsd) + rawShippingCost;
    const manualDiscountVal = Number(_updatedOfferPriceGroup?.discountManual) || 0;
    const basePercentDiscount = Number(_updatedOfferPriceGroup?.discount) || 0;
    let discountAmount = 0;
    if (basePercentDiscount > 0) {
      discountAmount += (combined * basePercentDiscount) / 100;
    }
    if (manualDiscountVal > 0) {
      let manualAmount = 0;
      if (_updatedOfferPriceGroup?.discountType === false) {
        manualAmount = (combined * manualDiscountVal) / 100;
      } else {
        manualAmount = manualDiscountVal;
      }
      discountAmount += manualAmount;
    }
    const sanitizedOrderGroup = {
      ..._updatedOfferPriceGroup,
      totalPrice: sums.lak,
      sumPriceBaht: sums.baht,
      sumPriceUsd: sums.usd,
      sumPrice: combined - discountAmount,
      discountAmountApplied: discountAmount,
      commissionPlatforms: commissionChannel,
      commissionTotal,
      rateBaht,
      rateUsd,
      ...(settingObject?.taxes?.taxStatus && (() => {
        const vatResult = calculateVat(combined - discountAmount, settingObject.taxes);
        return {
          taxes: {
            taxStatus: true,
            tax: settingObject.taxes.tax,
            taxType: settingObject.taxes.taxType,
            isVatIncluded: vatResult.isVatIncluded,
            priceBeforeTax: vatResult.priceBeforeTax,
            taxAmount: vatResult.taxAmount,
          }
        };
      })())
    };
    // Remove fields not in OrderGroupInput schema
    delete sanitizedOrderGroup.commissionType;
    delete sanitizedOrderGroup.channel;
    delete sanitizedOrderGroup.commissionPlatform;

    const _newOfferpriceDataWithOfferpriceGroup = {
      ...selectedCart?.data,
      orders: updatedOfferprices,
      orderGroup: sanitizedOrderGroup
    };
    
      if (activeTab === "TRANSFER" && shopData?.shop?.isPaymentGateway) {
        const res = await createManyPendingOrderWithOrderGroup({
          variables: { data: _newOfferpriceDataWithOfferpriceGroup },
        });

        if (res?.data?.createPreOrderGroupWithPaymentGateway) {
          handleGenQRForPayment(res?.data?.createPreOrderGroupWithPaymentGateway);
        }
        // //* Get generate new order code
        // await _loadGenCode();
        return;
      } else {
        // await createManyOrderWithOrderGroup({
        // Prepare refetch variables for user confirm after successful order creation
        const _userConfirmWhere = {
          shop: shopId,
          isDeleted: false,
        };
        if (searchcustomer !== "") {
          _userConfirmWhere.searchKeyWord = searchcustomer;
        }
        if (selectUserType !== "") {
          _userConfirmWhere.userType = selectUserType;
        }

        const _refetchQueries = [
          { query: GET_REWARDS_V2 },
          { query: GET_USER_CONFIRM, variables: { orderBy: "createdAt_DESC", where: _userConfirmWhere } },
        ];
        if (!_.isEmpty(customerId)) {
          _refetchQueries.push({ query: GET_USER_CONFIRM_ONE, variables: { where: { id: customerId } } });
        }

        const { data: _createManyOrderWithOrderGroupV4 } = await createManyOrderWithOrderGroupV4({
          variables: { data: _newOfferpriceDataWithOfferpriceGroup },
          refetchQueries: _refetchQueries,
          awaitRefetchQueries: true,
        });
        if (_createManyOrderWithOrderGroupV4?.createManyOrderWithOrderGroupV4?.id) {
          if (shouldPrintBill) {
            await onPrintBill();
          }
          handleClearCartDatas();
          return successSwal("ສໍາເລັດການຂາຍ");
        } else {
          return errorSwal("ມີຂໍ້ຜິດພາດ ກະລຸນາລີເຟສແລ້ວລອງໃຫມ່");
        }
      }
    } catch (err) {
      console.log(err?.message);
      errorSwal("ມີຂໍ້ຜິດພາດ");
      setLoadingPrintBill(false);
      setLoadingSaleBill(false)
      return;
    }
  };

  const onCreateManyOrderWithOrderGroupNotYetPaid = useCallback(async () => {
    try {
      if (editdata?.isEdited) {
        return _saleOfferPrice();
      }

      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);

      if (!selectedCart) {
        return;
      }

      const { orders, orderGroup } = selectedCart?.data;
      const staffFirstName =
        staffname?.data?.firstName || staffname?.data?.nickname;

      let _updatedOfferPriceGroup = {
        ...orderGroup,
        shop: shopId,
        customerName: customername,
        customerLastName: customerLastName,
        village: village,
        district: district,
        province: province,
        phone: phonenumber,
        staff: staffFirstName,
        staffLastname: staffname?.data?.lastName,
        payment: activeTab === "ເງິນໂອນ" ? "TRANSFER" : "CASH",
        change: parseFloat(change),
        currency: selectedPayCurrency,
        receivedMoney: parseFloat(receivedMoney),
        rateBaht: parseFloat(prepareRate?.baht || 1),
        rateUsd: parseFloat(prepareRate?.usd || 1),
      };
      if (!_.isEmpty(customerId)) _updatedOfferPriceGroup = { ..._updatedOfferPriceGroup, userConfirm: customerId };

      const commissionChannel =
        _updatedOfferPriceGroup?.commissionPlatforms ||
        channelName ||
        "POS";
      const updatedOfferprices = orders.map((order) => {
        const {
          totalAmount,
          brand,
          priceOptions,
          product,
          category,
          productVariant,
          stock,
          commissionPlatforms: _commissionPlatforms,
          commissionPlatform: _commissionPlatform,
          commissionType: _commissionType,
          commissionValue: _commissionValue,
          ...rest
        } = order;
        const commissionMatch = getCommissionMatchForOrder(order, commissionChannel);
        const normalizedChildren = normalizeChildrenStockForPayload(order?.children);
        return {
          ...rest,
          children: normalizedChildren,
          stock: stock ?? order?.product,
          productVariant: productVariant || undefined,
          commissionPlatform: commissionMatch?.platform || commissionChannel,
          commissionType: commissionMatch?.commissionType,
          commissionValue: commissionMatch?.commissionValue || 0,
        };
      });

      const commissionTotal = getCommissionTotalFromOrders(
        orders,
        commissionChannel,
        prepareRate?.baht,
        prepareRate?.usd,
      );
      const finalOrderGroup = {
        ..._updatedOfferPriceGroup,
        commissionPlatforms: commissionChannel,
        commissionTotal,
        ...(settingObject?.taxes?.taxStatus && (() => {
          const sumPrice = parseFloat(_updatedOfferPriceGroup?.sumPrice || 0);
          const vatResult = calculateVat(sumPrice, settingObject.taxes);
          return {
            taxes: {
              taxStatus: true,
              tax: settingObject.taxes.tax,
              taxType: settingObject.taxes.taxType,
              isVatIncluded: vatResult.isVatIncluded,
              priceBeforeTax: vatResult.priceBeforeTax,
              taxAmount: vatResult.taxAmount,
            }
          };
        })())
      };

      delete finalOrderGroup.commissionType;
      delete finalOrderGroup.channel;
      delete finalOrderGroup.commissionPlatform;

      const _newOfferpriceDataWithOfferpriceGroup = {
        ...selectedCart?.data,
        orders: updatedOfferprices,
        orderGroup: finalOrderGroup,
      };

      await createManyOrderWithOrderGroupNotYetPaid({
        variables: { data: _newOfferpriceDataWithOfferpriceGroup },
      });

      handleClearCartDatas();
      return successSwal("ສໍາເລັດການຂາຍ");
    } catch (err) {
      console.log(err?.message);
      errorSwal("ມີຂໍ້ຜິດພາດ");
      return;
    }
  }, [
    editdata,
    cartDatas,
    activeCart,
    customername,
    customerLastName,
    village,
    district,
    province,
    phonenumber,
    staffname,
    activeTab,
    change,
    selectedPayCurrency,
    receivedMoney,
    createManyOrderWithOrderGroupNotYetPaid,
    setShowDetailSaleModal,
    fetchProductData,
    handleRemoveCart,
    setChange,
    setReceivedMoney,
    setCartDatas,
    setLoadingPrintBill,
    setLoadingSaleBill,
  ]);

  //TODO: ຕີດຫນີ້ບໍ່ຮັບບີນ
  const onCreateManyOrderWithOrderGroupIndebTed = async () => {
    try {
      if (createOrderIndebTedLoading) return;
      if (editdata?.isEdited) {
        return _saleOfferPrice();
      }
      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
      if (!selectedCart) {
        return;
      }

      const { orders, orderGroup } = selectedCart.data;

      const staffFirstName =
        staffname?.data?.firstName || staffname?.data?.nickname;
      let _updatedOfferPriceGroup = {
        ...orderGroup,
        shop: shopId,
        customerId: customerId,
        customerName: customername,
        customerLastName: customerLastName,
        village,
        district,
        province,
        phone: phonenumber,
        staff: staffFirstName,
        staffLastname: staffname?.data?.lastName,
        payment: activeTab,
        change: parseFloat(change),
        currency: selectedPayCurrency,
        receivedMoney: parseFloat(receivedMoney),
        paymentDate: paymentDate,
        rateBaht: parseFloat(prepareRate?.baht || 1),
        rateUsd: parseFloat(prepareRate?.usd || 1),
      };
      if (!_.isEmpty(customerId)) _updatedOfferPriceGroup = { ..._updatedOfferPriceGroup, userConfirm: customerId };

      const commissionChannel =
        _updatedOfferPriceGroup?.commissionPlatforms ||
        channelName ||
        "POS";
      const updatedOfferprices = orders.map((order) => {
        const {
          totalAmount,
          brand,
          priceOptions,
          product,
          category,
          productVariant,
          stock,
          commissionPlatforms: _commissionPlatforms,
          commissionPlatform: _commissionPlatform,
          commissionType: _commissionType,
          commissionValue: _commissionValue,
          ...rest
        } = order;
        const commissionMatch = getCommissionMatchForOrder(order, commissionChannel);
        const normalizedChildren = normalizeChildrenStockForPayload(order?.children);
        return {
          ...rest,
          children: normalizedChildren,
          stock: stock ?? order?.product,
          productVariant: productVariant || undefined,
          commissionPlatform: commissionMatch?.platform || commissionChannel,
          commissionType: commissionMatch?.commissionType,
          commissionValue: commissionMatch?.commissionValue || 0,
        };
      });

      // split discount in order group
      // const { discount, discountType, ...restOrderGroup } = _updatedOfferPriceGroup;
      // console.log("restOrderGroup", restOrderGroup);

      const commissionTotal = getCommissionTotalFromOrders(
        orders,
        commissionChannel,
        prepareRate?.baht,
        prepareRate?.usd,
      );
      const finalOrderGroup = {
        ..._updatedOfferPriceGroup,
        commissionPlatforms: commissionChannel,
        commissionTotal,
        ...(settingObject?.taxes?.taxStatus && (() => {
          const sumPrice = parseFloat(_updatedOfferPriceGroup?.sumPrice || 0);
          const vatResult = calculateVat(sumPrice, settingObject.taxes);
          return {
            taxes: {
              taxStatus: true,
              tax: settingObject.taxes.tax,
              taxType: settingObject.taxes.taxType,
              isVatIncluded: vatResult.isVatIncluded,
              priceBeforeTax: vatResult.priceBeforeTax,
              taxAmount: vatResult.taxAmount,
            }
          };
        })())
      };

      delete finalOrderGroup.commissionType;
      delete finalOrderGroup.channel;
      delete finalOrderGroup.commissionPlatform;

      const _newOfferpriceDataWithOfferpriceGroup = {
        ...selectedCart.data,
        orders: updatedOfferprices,
        orderGroup: finalOrderGroup, //restOrderGroup,
      };

      await createManyOrderWithOrderGroupIndebTedV3({
        variables: { data: _newOfferpriceDataWithOfferpriceGroup },
      });

      handleClearCartDatas();
      fetchProductData();
      setShowAddCustomerIndebTed(false);
      setNotYetPaid(false);
      setCustommerName();
      setCustomerId();
      setCustommerLastName();
      setVillage();
      setDistrict();
      setProvince();
      setSelectUserConfirm();
      setPhoneNumber();

      return successSwal('ສໍາເລັດການຂາຍ');
    } catch (error) {
      console.log("error: ", error);
      errorSwal("ມີຂໍ້ຜິດພາດ");
    }
  };

  // print to usb and reduc stock ------------->
  const handleCreateOrderForPrintUsb = () => {
    onCreateManyOrderWithOrderGroup(true);
  };

  // ຮັບບິນ
  const createOrderPrintBill = async () => {
    try {
      //* Create order pending payment
      if (activeTab === "TRANSFER" && shopData?.shop?.isPaymentGateway) {
        setLoadingPrintBill(true);
        onCreateManyOrderWithOrderGroup(true);
        setisNeededBill(true);
      } else {
        //* Create order success
        setLoadingPrintBill(true);
        await onCreateManyOrderWithOrderGroup(true);
      }
    } catch (error) {
      console.log("Error in createOrderPrintBill: ", error);
    }
  };

  // ບໍ່ຮັບບິນ
  const createOrderNotPrintBill = () => {
    setLoadingSaleBill(true);
    onCreateManyOrderWithOrderGroup(false);
  };

  // generate QR for payment
  const handleGenQRForPayment = async (order) => {
    const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));
    try {
      const headers = {
        "Content-Type": "application/json",
        secretKey: KEY,
      }
      const bodyData = {
        // amount: 1,
        amount: order?.sumPrice,
        description: "4B_POS",
        tag1: shopData?.id,   //tag1 = is shopId
        tag2: shopData?.name,  // tag2 = is shopName
        tag3: order?.id // tag3 = is orderGroupId
      }
      // const response = await axios.post(`${PAYMENT_GATEWAY_API_URL}/v1/api/payment/generate-bcel-qr`, bodyData, { headers });
      const response = await axios.post(`${PAYMENT_GATEWAY_API_URL}/v1/api/payment/generate-jdb-qr`, bodyData, { headers });
      if (response?.status === 200) {
        setLoadingPrintBill(false);
        setLoadingSaleBill(false);
        localStorage.setItem("PAYMENT_QR_DATA", JSON.stringify(response?.data)); // save to localStorage for show in customer screen
        console.log("response: ", response?.data);
        setPaymentQR(response?.data);
      }
    } catch (error) {
      setLoadingPrintBill(false);
      setLoadingSaleBill(false);
      console.log("error: ", error);
      errorSwal("ມີຂໍ້ຜິດພາດ");
    }
  }

  //TODO: Update orders  when Edit
  const _updateorders = async () => {
    try {
      if (orderGroupV2Loading) return;

      // TODO: Find cart data
      const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
      if (!selectedCart) return;

      // TODO: Get orders and order group
      const { orders, orderGroup } = selectedCart?.data;

      const commissionChannel =
        orderGroup?.commissionPlatforms ||
        orderGroup?.commissionType ||
        orderGroup?.channel ||
        channelName ||
        "POS";

      const resolveCommissionFromOrder = (order, channelValue) => {
        if (
          order?.commissionPlatform &&
          order?.commissionType !== undefined &&
          order?.commissionType !== null &&
          order?.commissionValue !== undefined &&
          order?.commissionValue !== null
        ) {
          return {
            platform: order?.commissionPlatform,
            commissionType: order?.commissionType,
            commissionValue: order?.commissionValue,
          };
        }

        if (Array.isArray(order?.commissionPlatforms) && order?.commissionPlatforms.length > 0) {
          const channel = String(channelValue || "").toUpperCase();
          const match =
            order.commissionPlatforms.find(
              (platform) =>
                String(platform?.platform || platform || "").toUpperCase() === channel,
            ) || order.commissionPlatforms[0];
          if (match) {
            return {
              platform: match?.platform || match,
              commissionType: match?.commissionType,
              commissionValue: match?.commissionValue,
            };
          }
        }

        return null;
      };

      const _newOrders = orders.map((order, index) => {
        const {
          totalAmount,
          brand,
          priceOptions,
          product,
          category,
          productVariant,
          stock,
          unit,
          commissionPlatforms: _commissionPlatforms,
          commissionPlatform: _commissionPlatform,
          commissionType: _commissionType,
          commissionValue: _commissionValue,
          children,
          survival,
          total,
          amountChild,
          volumeChild,
          ...rest
        } = order;
        const existingCommission = resolveCommissionFromOrder(order, commissionChannel);
        const commissionMatch =
          existingCommission || getCommissionMatchForOrder(order, commissionChannel);
        const commissionPlatformResolved =
          commissionMatch?.platform ||
          _commissionPlatform ||
          _commissionPlatforms ||
          commissionChannel;
        const commissionTypeResolved =
          commissionMatch?.commissionType || _commissionType;
        const commissionValueResolved =
          commissionMatch?.commissionValue ?? _commissionValue ?? 0;
        if (order?.children) {
          const newChildren = order?.children.map((child) => {
            const productName = child?.productName || child?.product?.name || "";
            const stockObject =
              child?.stock && typeof child?.stock === "object"
                ? child?.stock
                : child?._stock && typeof child?._stock === "object"
                  ? child?._stock
                  : null;
            const stock =
              stockObject ??
              (child?.stock
                ? (typeof child.stock === "object" ? child.stock : { id: child.stock })
                : null);
            const stockIdResolved = stock?.id ?? stockObject?.id ?? (typeof stock === "string" ? stock : undefined);
            const originStock =
              stockIdResolved && Array.isArray(originProducts)
                ? originProducts.find((p) => p?.id === stockIdResolved)
                : undefined;
            const unitIdResolved =
              stock?.unitId ?? stockObject?.unitId ?? originStock?.unitId;
            const unitIdPayload =
              unitIdResolved && typeof unitIdResolved === "object"
                ? { id: unitIdResolved?.id, name: unitIdResolved?.name }
                : unitIdResolved
                  ? { name: unitIdResolved }
                  : undefined;
            const dimensionSource =
              stock?.dimension ?? stockObject?.dimension ?? originStock?.dimension;
            const dimensionResolved = {
              length: dimensionSource?.length ?? 0,
              width: dimensionSource?.width ?? 0,
              height: dimensionSource?.height ?? 0,
              weight: dimensionSource?.weight ?? 0,
            };
            const stockPayload = stock
              ? {
                  id: stockIdResolved ?? stock,
                  name: stock?.name ?? stockObject?.name ?? originStock?.name,
                  amount: stock?.amount ?? stockObject?.amount ?? originStock?.amount,
                  price: stock?.price ?? stockObject?.price ?? originStock?.price,
                  size: stock?.size ?? stockObject?.size ?? originStock?.size,
                  unit: stock?.unit ?? stockObject?.unit ?? originStock?.unit ?? null,
                  unitId: unitIdPayload,
                  dimension: dimensionResolved,
                  currency: stock?.currency ?? stockObject?.currency ?? originStock?.currency ?? "",
                }
              : null;
            const amount = parseInt(child?.amount || 0, 10);
            const volume = child?.volume ? parseInt(child?.volume, 10) : undefined;
            const price = parseFloat(child?.price || 0);
            const totalPrice = parseFloat(child?.totalPrice || 0);
            const tag = (String(child?.saleTag || "").toUpperCase() === "FREE") ? "FREE" : (child?.tag || undefined);
            const currency = child?.currency || rest?.currency || "LAK";
            const unitResolved = child?.unit || stockObject?.unitId?.name || stockObject?.unit || unit;
            const sanitized = {
              productName,
              stock: stockPayload,
              unit: unitResolved,
              amount,
              price,
              totalPrice,
              tag,
              currency,
            };
            if (volume !== undefined) sanitized.volume = volume;
            return sanitized;
          });
          return {
            ...rest,
            stock: stock ?? order?.product,
            productVariant: productVariant || undefined,
            sortId: String(index + 1),
            children: newChildren,
            commissionPlatform: commissionPlatformResolved,
            commissionType: commissionTypeResolved,
            commissionValue: commissionValueResolved,
          };
        } else {
          return {
            ...rest,
            stock: stock ?? order?.product,
            productVariant: productVariant || undefined,
            sortId: String(index + 1),
            commissionPlatform: commissionPlatformResolved,
            commissionType: commissionTypeResolved,
            commissionValue: commissionValueResolved,
          };
        }
      });
      
      const commissionTotal = getCommissionTotalFromOrders(
        _newOrders,
        commissionChannel,
        prepareRate?.baht,
        prepareRate?.usd,
      );

      const _receivedMoney = orderGroup?.receivedMoney || 0;
      const _sumPrice = orderGroup?.sumPrice || 0;
      const _change = _receivedMoney - _sumPrice;
      const playloadUpdateOrder = {
        amount: orderGroup?.amount,
        volume: orderGroup?.volume,
        sumPrice: orderGroup?.sumPrice,
        totalPrice: orderGroup?.totalPrice,
        sumPriceBaht: orderGroup?.sumPriceBaht,
        sumPriceUsd: orderGroup?.sumPriceUsd,
        currency: orderGroup?.currency ?? "LAK",
        customerName: customername,
        phone: phonenumber,
        customerLastName: customerLastName,
        village: village,
        district: district,
        province: province,
        orders: _newOrders,
        userConfirm: customerId,
        discount: orderGroup?.discount ?? 0,
        change: _change,
        receivedMoney: _receivedMoney,
        commissionPlatforms: commissionChannel,
        commissionTotal,
      }
      // console.log("order update....", playloadUpdateOrder);
      // await updateOrdergroup({
      await updateOrderGroupV2({
        variables: {
          where: {
            id: editdata?.state?.id,
          },
          data: playloadUpdateOrder,
        },
      });

      setCustommerName("");
      setPhoneNumber("");
      // history.push("/salehistory/limit/50/page/1");
      let newDataUpdate = {
        ...playloadUpdateOrder,
        id: editdata?.state?.id,
        code: editdata?.state?.code,
        payment: editdata?.state?.payment,
        createdAt: editdata?.state?.createdAt,
        status: editdata?.state?.status,
        staff: editdata?.state?.staff,
        staffLastname: editdata?.state?.staffLastname,
      }
      history.push("/order_detail", {
        state: newDataUpdate,
      });
      successSwal("ເເກ້ໄຂອໍເດີສຳເລັດ");
    } catch (err) {
      errorSwal("ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
      // console.log("error creating todo:", err);
    }
  };

  const _saleOfferPrice = async () => {
    if (saleOfferPriceLoading) return;
    const shopId = await JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    // TODO: Find cart data
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;

    // TODO: Get orders and order group
    const { orders, orderGroup } = selectedCart?.data;

    const _newOfferPrices = orders.map((order) => {
      const { totalAmount, brand, priceOptions, category, ...rest } = order;
      return rest;
    });

    const _offerPrices = _newOfferPrices?.map((offerPrice) => {
      return {
        amount: offerPrice?.amount ?? 0,
        price: offerPrice?.price,
        totalPrice: offerPrice?.totalPrice,
        shop: orderGroup?.shop,
        stock: offerPrice?.stock ?? offerPrice?.product,
        productVariant: offerPrice?.productVariant || undefined,
        productName: offerPrice?.productName,
        currency: offerPrice?.currency ? offerPrice?.currency : "LAK",
      };
    });

    await saleOfferPrice({
      variables: {
        where: {
          id: editdata?.state?.id,
        },
        data: {
          amount: orderGroup?.amount,
          totalPrice: orderGroup?.totalPrice,
          receivedMoney: 0,
          change: 0,
          sumPrice: orderGroup?.sumPrice,
          sumPriceBaht: orderGroup?.sumPriceBaht,
          sumPriceUsd: orderGroup?.sumPriceUsd,
          currency: selectedPayCurrency
            ? selectedPayCurrency
            : orderGroup?.currency ?? "LAK",
          shop: orderGroup?.shop,
          payment: orderGroup?.payment ?? "CASH",
          offerprices: _offerPrices,
        },
      },
    });

    setShowDetailSaleModal(false);
    // TODO: Clear bill
    handleRemoveCart({ label: activeCart, isRemove: true });
    setActiveTab("CASH");
    setChange(0);
    setReceivedMoney("0");

    history.replace();
    if (cartDatas?.length <= 1) {

      setCartDatas([]);
    }
    history.goBack(-1);
    // history.push("/history_offerprices");
    // TODO: Show modal success
    return successSwal("ສໍາເລັດການຂາຍ");
  };

  const getPageSize = () => {
    return `@page { 
             size: 210mm  297mm
          !important; }`;

    // return `@page { size: 3508px  2480px !important; }`;
  };

  // ==========> Fuction Prin Bill <==========
  let bill80Ref = useRef(null);
  let bill58Ref = useRef(null);
  let billA4Ref = useRef(null);
  let currentBillA4Ref = useRef(null);
  useLayoutEffect(() => {
    setWidthBill80(bill80Ref.current.offsetWidth);
    setWidthBill58(bill58Ref.current.offsetWidth);
  }, [bill80Ref, bill58Ref]);

  const onPrintBill = async () => {
    try {
      const printerBillData = printer.find((e) => e?.status === true);

      const dataImageForPrint = await html2canvas(
        printerBillData?.width === "80mm"
          ? bill80Ref.current
          : bill58Ref.current,
        {
          useCORS: true,
          scrollX: 10,
          scrollY: printerBillData?.width === "80mm" ? 2 : 0,
          scale:
            printerBillData?.width === "80mm"
              ? 560 / widthBill80
              : 350 / widthBill58,
        }
      );


      const urlByType = {
        ETHERNET: "ethernet",
        BLUETOOTH: "bluetooth",
        USB: "usb",
      };
      const urlForPrinter = `http://localhost:9150/${urlByType[printerBillData?.type]
        }/image`;

      const _file = await base64ToBlob(dataImageForPrint.toDataURL());
      const bodyFormData = new FormData();
      bodyFormData.append("ip", printerBillData?.ip);
      bodyFormData.append("port", "9100");
      bodyFormData.append("image", _file);
      bodyFormData.append("beep1", 1);
      bodyFormData.append("beep2", 9);

      await axios.post(urlForPrinter, bodyFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const toastConfig = {
        icon: "success",
        title: "ປິນສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      };
      await Swal.fire(toastConfig);
      setLoadingPrintBill(false);
      if (isBillPrinting) {
        handleClearCartDatas();
      }
      // set time out
    } catch (err) {
      console.log(err);
      await Swal.fire({
        icon: "error",
        title: "ປິນບໍ່ສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
      setLoadingPrintBill(false);
    }
  };


  const handlePrintA4 = () => {
    if (createOrderIndebTedLoading) {
      return;
    }
    // localStorage.setItem("PRINT_ORDER", JSON.stringify({status: "INDEBTED"}));
    // const cartActive = cartDatas.findIndex((e) => e?.label === activeCart);
    // if (cartActive !== -1) {
    //   let newCartData = [...cartDatas];
    //   if (newCartData[cartActive].data.orderGroup.status) {
    //     newCartData[cartActive].data.orderGroup.status = "INDEBTED";
    //   } else {
    //     console.log("has status", newCartData[cartActive].data.orderGroup.status);
    //     newCartData[cartActive].data.orderGroup = {...newCartData[cartActive].data.orderGroup, status: "INDEBTED"};
    //   }
    //   console.log("has status v2", newCartData);
    //   setCartDatas(newCartData);
    // }
    setPreviewingA4(true);
    currentBillA4Ref.current.handlePrint();
  };

  // Check cart has selected
  const changeAllPrice = () => {
    const calculateTotalPrice = (order, newPrice) => {
      return order.amount * newPrice;
    };

    const getNewPrice = (order) => {
      const selectedPriceOption = order.priceOptions[selectedPrice];
      return selectedPriceOption?.price > 0 ||
        !_.isEmpty(selectedPriceOption?.price)
        ? selectedPriceOption?.price
        : order.price;
    };

    const calculateTotalPriceForCurrency = (order, newPrice) => {
      return calculateTotalPrice(order, newPrice);
    };

    const updateOrderPrices = (cart) => {
      return cart.data.orders.map((order) => {
        const newPrice = getNewPrice(order);
        const totalPrice = calculateTotalPriceForCurrency(order, newPrice);
        return { ...order, price: newPrice, totalPrice };
      });
    };

    const updateCartData = (cart) => {
      if (cart.label === activeCart) {
        const { orderGroup } = cart.data;
        return {
          ...cart,
          data: {
            orderGroup,
            orders: updateOrderPrices(cart),
          },
        };
      }
      return cart;
    };

    const updatedCartDatas = cartDatas?.map(updateCartData);


    if (!_.isEmpty(updatedCartDatas)) {

      setCartDatas(updatedCartDatas);
    }
  };

  // Filter user confirm
  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      if (!shopId) return;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      // Check if search text is not empty
      if (searchcustomer !== "") {
        _where = {
          ..._where,
          searchKeyWord: searchcustomer
        };
      }

      // User type
      if (selectUserType !== "") _where = { ..._where, userType: selectUserType };

      // Get all products
      await getuserConfirm({
        variables: {
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });

    } catch (error) {
      console.error("Error during filtering:", error);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') setSearchCustomer(e.target.value);
  };

  // select product to cart
  const onSelectProduct = useCallback(
    (product) => {
      // console.log("====", { product });
      if (product?.amount <= 0) {
        errorSwal(`ສິນຄ້າ  ${product?.name} ໝົດສະຕອັກ`);
        return;
      }

      if (cartDatas?.length <= 0) {
        errorSwal("ກະລຸນາເພີ່ມໃບບີນ");
        return;
      }

      //ລວມອໍເດີທັງໝົດໄວ້
      const checkOrder = cartDatas?.flatMap((item) => item?.data?.orders) || [];

      // filter by product id scan
      const filteredOrders = checkOrder.filter(
        (order) => order.product === product.id
      );

      // sum amount by product id scan
      const sumTotal = filteredOrders.reduce(
        (total, order) => total + order.amount,
        0
      );

      const _check = checkedProductSelected(product);

      if (!_check) {
        addOrder({ product, productPrice: 0 });
      } else {
        updateOrder({
          product,
          productId: product?.id,
          isAdded: true,
          changeValue: 0,
        });
      }
    },
    [cartDatas, errorSwal, addOrder, updateOrder]
  );

  const getScanProduct = useCallback(
    async (barCode) => {
      if (!barCode) return;

      try {
        const { data } = await getProductFromBarcode({
          variables: {
            where: {
              _id: barCode,
              shop: shopId,
              isDeleted: false
            },
          },
        });

        const result = data?.stocksByBarcode;
        if (!result) return;

        const { type, product, productVariant } = result;

        if (type === "VARIANT" && productVariant) {
          // Variant → ใช้ราคา/จำนวนจาก productVariant, ชื่อ/หมวดหมู่/แบรนด์จาก product (parent)
          const attributes = (productVariant?.attributeValues || [])
            .map((attr) => {
              const name = attr?.attribute?.name || "";
              const value = attr?.value || "";
              return name ? `${name}${value ? `: ${value}` : ""}` : value;
            })
            .filter(Boolean)
            .join(", ");

          const productName = `${productVariant?.product?.name ?? product?.name ?? "-"}`;
          const variantName = attributes ? `${productName} (${attributes})` : productName;

          const normalizedVariant = {
            id: productVariant?.id,
            name: variantName,
            amount: productVariant?.amount ?? 0,
            originAmount: productVariant?.originAmount,
            originPrice: productVariant?.originPrice,
            price: productVariant?.price,
            currency: productVariant?.currency,
            commissionPlatforms:
              productVariant?.commissionPlatforms ||
              product?.commissionPlatforms ||
              [],
            productVariant: productVariant?.id,
            stock: product?._id,
            priceOptions: [],
            brand: product?.brand,
            category: product?.category,
            unit: product?.unit,
            hasVariant: false,
          };

          onSelectProduct(normalizedVariant);
        } else if (type === "PRODUCT" && product) {
          // Product ธรรมดา → map _id → id
          const normalizedProduct = { ...product, id: product?._id };
          onSelectProduct(normalizedProduct);
        }
      } catch (error) {
        console.error(error);
        // Handle error, e.g., show an error message
      }
    },
    [getProductFromBarcode, onSelectProduct, shopId]
  );

  const checkedProductSelected = (product) => {
    let _check = false;

    const cartData = _.find(cartDatas, { label: activeCart });
    cartData?.data?.orders?.map((productId) => {
      if (product?.id === productId?.product) _check = true;
    });
    return _check;
  };

  const handleEditPriceProduct = (e, index) => {
    let _priceValue = e?.target?.value;
    let _price = parseFloat(_priceValue.replace(/,/g, ''));

    const getCartData = cartDatas?.filter((item) => item?.label === activeCart);
    const orderGroup = getCartData?.[0]?.data?.orderGroup;

    let newOrder = [...cartDatas];

    let updatePriceOrder = [...getCartData[0]?.data?.orders];
    const baseTotal = updatePriceOrder[index]?.amount * _price;

    updatePriceOrder[index] = {
      ...updatePriceOrder[index],
      price: _price,
      totalPrice: baseTotal,
    };

    newOrder = newOrder.map(cart =>
      cart?.label === activeCart ? { ...cart, data: { ...cart?.data, orders: updatePriceOrder } } : cart
    );

    setCartDatas(newOrder);
  };

  //* Handle close add user confirm
  const handleConfirmClose = () => {
    setShowAddCusTomerBill(false);
    setAddUserType('');
  }

  useEffect(() => {
    let storedLanguage;
    try {
      storedLanguage = localStorage.getItem("i18nextLng");
    } catch (error) {
      storedLanguage = undefined;
    }

    const normalized =
      normalizeLanguageCode(storedLanguage) ||
      normalizeLanguageCode(i18n.resolvedLanguage || i18n.language) ||
      "lao";
    setLanguageName(normalized);
  }, [i18n.language, i18n.resolvedLanguage])


  const handleChangeLanguage = async (lgn) => {
    const nextLanguage = normalizeLanguageCode(lgn) || "lao";
    i18n.changeLanguage(nextLanguage);
    setLanguageName(nextLanguage);
  };

  const convertLanguageName = (name) => {
    const normalized = normalizeLanguageCode(name) || "lao";
    switch (normalized) {
      case 'lao':
        return 'ພາສາລາວ';
      case 'en':
        return 'English';
      case 'chi':
        return '晉語';
      default:
        return 'ພາສາລາວ';
    }
  };

  const getCommissionMatchForOrder = (order, channelValue) => {
    const channel = String(channelValue || "").toUpperCase();
    if (
      order?.commissionPlatform &&
      String(order.commissionPlatform).toUpperCase() === channel
    ) {
      const hasCommissionData =
        order?.commissionType !== undefined &&
        order?.commissionType !== null &&
        order?.commissionValue !== undefined &&
        order?.commissionValue !== null;
      if (hasCommissionData) {
        return {
          platform: order?.commissionPlatform,
          commissionType: order?.commissionType,
          commissionValue: order?.commissionValue,
        };
      }
    }

    if (Array.isArray(order?.commissionPlatforms) && order.commissionPlatforms.length > 0) {
      const match = order.commissionPlatforms.find(
        (platform) => String(platform?.platform || platform || "").toUpperCase() === channel,
      );
      if (match) return match;
    }

    const productId = order?.product || order?.stock;
    const sourceProduct = (originProducts || []).find(
      (product) => product?.id === productId,
    );
    const platforms = sourceProduct?.commissionPlatforms || [];
    if (!Array.isArray(platforms)) return null;
    return (
      platforms.find(
        (platform) => String(platform?.platform || "").toUpperCase() === channel,
      ) || null
    );
  };

  const getCommissionPlatformFromOrders = (orders, channelValue) => {
    const list = Array.isArray(orders) ? orders : [];
    for (const order of list) {
      const match = getCommissionMatchForOrder(order, channelValue);
      if (match?.platform) return match.platform;
    }
    return undefined;
  };

  const getCommissionTotalFromOrders = (orders, channelValue, rateBaht, rateUsd) => {
    const list = Array.isArray(orders) ? orders : [];
    const channel = String(channelValue || "").toUpperCase();
    let total = 0;
    list.forEach((order) => {
      const match = getCommissionMatchForOrder(order, channel);
      if (!match?.commissionValue) return;
      const type = String(match?.commissionType || "").toUpperCase();
      const amount = Number(order?.amount || 0) || 0;
      const baseTotal = Number(order?.totalPrice || 0) || (Number(order?.price || 0) * amount);
      let lineCommission = 0;
      if (type === "PERCENT" || type === "PERCENTAGE") {
        lineCommission = (baseTotal * Number(match?.commissionValue || 0)) / 100;
      } else {
        lineCommission = (Number(match?.commissionValue || 0) || 0) * amount;
      }
      switch (order?.currency) {
        case "BAHT":
        case "ບາດ":
          total += lineCommission * (Number(rateBaht) || 1);
          break;
        case "USD":
        case "ໂດລາ":
          total += lineCommission * (Number(rateUsd) || 1);
          break;
        default:
          total += lineCommission;
          break;
      }
    });
    return total;
  };

  const convertChannelName = (value) => {
    const match = channelTypes.find((item) => item.value === value);
    return match ? match.name : value || "-";
  };

  const handleChangeChannel = (value) => {
    const nextValue =
      channelTypes.find((item) => item.value === value)?.value || value;
    setChannelName(nextValue);
    setCartDatas((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      return list.map((cart) => {
        if (cart?.label !== activeCart) return cart;
        const updatedOrders = (cart?.data?.orders || []).map((order) => {
          const match = getCommissionMatchForOrder(order, nextValue);
          return {
            ...order,
            commissionPlatform: match?.platform || nextValue,
            commissionType: match?.commissionType,
            commissionValue: match?.commissionValue || 0,
          };
        });
        const commissionPlatform = getCommissionPlatformFromOrders(
          updatedOrders,
          nextValue,
        );
        const commissionTotal = getCommissionTotalFromOrders(
          updatedOrders,
          nextValue,
          prepareRate?.baht,
          prepareRate?.usd,
        );
        return {
          ...cart,
          data: {
            ...cart?.data,
            orders: updatedOrders,
            orderGroup: {
              ...cart?.data?.orderGroup,
              commissionPlatforms: commissionPlatform || nextValue,
              commissionTotal,
            },
          },
        };
      });
    });
  };

  // add free amount on orders
  const handleAddAmountFree = async (e) => {
    e.preventDefault();
    try {
      const _cartIndex = isFreeStatus?.cartIndex;
      const orderIndex = isFreeStatus?.preOrder?.oIndex;
      let _amountFree = parseInt(isFreeStatus?.preOrder?.order?.amountFree);

      // Ensure that the orderIndex and _amountFree are valid
      if (orderIndex === undefined || orderIndex < 0 || isNaN(_amountFree)) {
        console.error("Invalid order index or amountFree");
        return;
      }

      // Update the cartDatas state
      setCartDatas(prevCart =>
        prevCart.map(cart =>
          cart.id === _cartIndex
            ? {
              ...cart,
              data: {
                ...cart.data,
                orders: cart.data.orders.map((order, index) =>
                  index === orderIndex
                    ? {
                      ...order,
                      amountFree: _amountFree, // Add/update `amountFree`
                    }
                    : order // Leave other orders unchanged
                ),
              },
            }
            : cart // Leave other carts unchanged
        )
      );

      onCloseFreeStatus(); // Close the free status modal or UI

    } catch (error) {
      console.error("Error adding amountFree to order:", error);
    }
  };

  const handlePlayer = () => {
    soundPlayer.current.audioEl.current.play()
  }

  const onCloseFreeStatus = () => {
    setIsFreeSatus({
      isOpen: false,
      preOrder: null
    })
  }
  

  return (
    <>
      <ReactAudioPlayer
        src="/assets/notication_success.mp3"
        ref={soundPlayer} />

      <div style={{ maxWidth: width > 700 ? "40vw" : '100%', minWidth: '40vw', marginLeft: width > 700 ? "10px" : 0, height: width > 700 ? "100vh" : 'auto', position: 'relative' }}>

        <Modal centered show={showSalePageQr} onHide={() => { setShowSalePageQr(false); setCopiedSalePageLink(false); }}>
          <Modal.Header closeButton>
            <Modal.Title>QR ຮ້ານເຊລເພຈ</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "2em" }}>
            <QRCode id="salepage-qr" value={salePageUrl} size={width > 700 ? 220 : 180} />
            <div style={{ marginTop: 16, fontSize: 12, textAlign: "center", wordBreak: "break-all" }}>
              {salePageUrl}
            </div>
            <div
              style={{ marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, cursor: "pointer" }}
              onClick={handleCopySalePageLink}
            >
              {copiedSalePageLink ? (
                <IoCheckmarkDoneSharp style={{ fontSize: 20, color: APP_COLOR }} />
              ) : (
                <ContentCopyIcon style={{ fontSize: 18 }} />
              )}
              <span>ຄັດລອກ</span>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={handleDownloadQr}>{t("download", { defaultValue: "ດາວໂຫລດ" })}</Button>
          </Modal.Footer>
        </Modal>

        <Modal centered show={isFreeStatus?.isOpen} onHide={onCloseFreeStatus}>
          <Modal.Header>
            <Modal.Title>{isFreeStatus?.preOrder?.order?.productName}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "4em" }}>
            <Form onSubmit={handleAddAmountFree}>
              <Row style={{ marginTop: "-3em" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>ຈຳນວນ ຂາຍ</Form.Label>
                    <Form.Control readOnly disabled type="text" value={isFreeStatus?.preOrder?.order?.amount} />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>ແຖມ</Form.Label>
                    <Form.Control autoFocus type="text"
                      placeholder="..."
                      value={isFreeStatus?.preOrder?.order?.amountFree}
                      onChange={(e) => setIsFreeSatus({ ...isFreeStatus, preOrder: { ...isFreeStatus?.preOrder, order: { ...isFreeStatus?.preOrder?.order, amountFree: e?.target?.value } } })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="d-flex gap-2 justify-content-end align-items-center mt-4">
                <Button type="button" variant="light" onClick={onCloseFreeStatus}>
                  ຍົກເລີກ
                </Button>
                <Button type="submit" variant="light" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE }}>
                  ຢືນຢັນ
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <Modal show={createOrderIndebTedLoading || createOrderLoadingV4}>
          <Modal.Body>
            <AnimationLoading />
          </Modal.Body>
        </Modal>

        {/* //TODO: Plus Stock Modal */}
        {showPlusStockModal &&
          <PlusOptionModal showPlusStockModal={showPlusStockModal} setShowPlusStockModal={setShowPlusStockModal}
            plusStock={plusStock} setPlusStock={setPlusStock} cartDatas={cartDatas} setCartDatas={setCartDatas}
          />
        }

        {width > 700 && <div className="sale-cart-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>

          <span
            style={{
              fontSize: "25px",
              fontStyle: "normal",
              fontWeight: "bold",
            }}
          >
            <FaCartArrowDown style={{ fontSize: 28,color:COLOR_APP }}/> <span>({totalAmount})</span>
          </span>
          <div className="d-flex justify-content-end gap-2 align-items-center">
            {/* <Button onClick={handlePlayer}>Open Notic v4</Button> */}
            {/* สร้าง select option เลือกสช่องทางขาย มี value:POS name:ໜ້າຮ້ານ กับ value:ONLINE name:ອອນໄລນ໌ */}
            {commissionEnable && (
              <DropdownButton variant="light" id="dropdown-item-button" title={convertChannelName(channelName)}>
                {channelTypes.map((item, index) => (
                  <Dropdown.Item key={index} as="button" onClick={() => handleChangeChannel(item?.value)} style={{ display: 'flex', gap: 5, paddingBottom: 0, paddingTop: 5 }}>
                    <span>{item?.name}</span>
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            )}

            <CustomButton
              title={"ເຊລເພຈ"}
              icon={<QrCode2Icon style={{ fontSize: 16 }} />}
              width={100}
              height={40}
              borderRadius="6px"
              background={"#6B7280"}
              color={COLOR_WHITE}
              padding="4px 8px"
              onClick={handleGenerateQr}
            />
            <Button variant="light" onClick={() => setIsCustomerScreen({ isOpen: true, data: null })} >{t("customer_screen_btn", { defaultValue: "ຈໍລູກຄ້າ" })}</Button>
            <DropdownButton variant="light" id="dropdown-item-button" title={convertLanguageName(languageName)}>
              {languageTypes.map((item, index) => (
                <Dropdown.Item key={index} as="button" onClick={() => handleChangeLanguage(item?.name)} style={{ display: 'flex', gap: 5, paddingBottom: 0, paddingTop: 5 }}>
                  <img src={item?.flag} alt={`${item?.title} flag`} style={{ width: 25, height: 25, borderRadius: '50%' }} />
                  <p>{item?.title}</p>
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>
        </div>
        }

        {width > 700 && <div style={{ zIndex: "100", position: "absolute", right: "0", marginRight: "0.85rem" }}>
          {totalAmount >= 1 ? (
            <div className="d-flex gap-2 justify-content-end align-items-center mt-2">
              {
                shopSetting?.editPriceBeforeSale ? null : (
                  <Button
                    size="sm"
                    onClick={openEditPrice ? handleCloseRemoveProduct : handleShowConfirmProduct}

                    variant="light"
                  >
                    <ReactIcons.FaEdit />   {openEditPrice ? t("off_edit_price_name") : t("on_edit_price_name")}
                  </Button>
                )
              }

            </div>
          ) : (
            ""
          )}
        </div>}


        <Tabs
          activeKey={activeCart}
          id="fill-tab-example"
          style={{ background: "#fff", borderBottom: 'none', maxHeight: 58 }}
          // fill={cartDatas?.length > 2 ? true : false}
          onSelect={(e) => handleSelect(e)}>
          {cartDatas.map((cart, cIndex) => {
            return (

              <Tab
                style={{ borderBottom: "none", borderRadius: 'none' }}
                key={cart + cIndex}
                eventKey={cart.label}

                title={
                  <div style={{ display: width > 700 ? "flex" : "none", borderRadius: 'none', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ fontSize: 14, margin: "0px 20px 0px 0px" }}>
                      {cart.label + " "}
                    </div>
                    <div>
                      <Close
                        onClick={() =>
                          handleRemoveCart({ label: cart.label, isRemove: true })
                        }
                        style={{ cursor: "pointer", fontSize: 16 }}
                      />
                    </div>
                  </div>
                }>
                <div
                  style={{
                    height: width > 700 ? "95vh" : "76vh",
                    paddingBottom: 50,
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}>
                  <div
                    className="sale-cart-list-main"
                    style={{
                      height: width > 700 ? "75vh" : '60vh',
                    }}
                    ref={containerRef}
                  >

                    {!_.isEmpty(cart?.data?.orders) ? (

                      <Table bordered responsive style={{ fontSize: 13 }}>
                        <thead>
                          <tr>
                            <th style={{ fontSize: 12 }}>{t("product_name_tb")}</th>
                            <th style={{ borderTop: "none", fontSize: 12 }}>ຂະຫນາດ</th>
                            <th width="10%" style={{ fontSize: 12 }}>{t("qty_name_tb")}</th>
                            <th style={{ fontSize: 12 }}>ແຖມ</th>
                            <th style={{ fontSize: 12 }}>{t("price_name_tb")}</th>
                            {/* <th style={{fontSize: 12}}>{t("total_price_tb")}</th> */}
                            <th style={{ fontSize: 12 }}>{t("sum_price_tb")}</th>
                            <th width="5%" style={{ fontSize: 12 }}>{t("deleted_name_tb")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cart?.data?.orders.map((order, oIndex) => (
                            <React.Fragment key={oIndex}>
                              <tr key={oIndex}>
                                <td>
                                  <div className="d-flex flex-column gap-1">
                                    <p style={{ fontSize: 12 }}>
                                      {oIndex + 1}. {order?.productName ?? "-"}
                                    </p>
                                    {(shopData?.shop?.id === "678db8f1942eb6002c1f40cd" ||
                                      shopData?.shop?.id === "63ec6d38c617221e6ccf5edc"
                                    ) && <Add
                                        onClick={() => handlePlusStock(order, oIndex, cart, cIndex)}
                                        sx={{
                                          cursor: "pointer",
                                          color: "#5CB338",
                                          fontSize: 18,
                                          marginTop: -2,
                                        }}
                                      />}
                                  </div>
                                </td>
                                <td style={{ fontSize: 12 }}>
                                  {order?.size ?? '-'}
                                  {order?.dimension?.length ? '(' + order?.dimension?.length + 'x' + order?.dimension?.width + 'x' + order?.dimension?.height + 'x' + order?.dimension?.weight + ')' : ''}
                                </td>

                                <td style={{ padding: "1px 4px" }}>
                                  <Form.Control
                                    max={order?.totalAmount}
                                    style={{
                                      width: 50, textAlign: 'center',
                                      borderRadius: 10,
                                      fontSize: 12
                                    }}
                                    name="amount"
                                    type="text"
                                    onChange={(e) => {
                                      const value = parseInt(e.target.value);
                                      const isLessStocks = shopData?.shop?.isLessStocks;

                                      if (value < 0) {
                                        errorSwal('ຈຳນວນສີນຄ້າຕ້ອງ ຫລາຍກ່ອນ 0 ເດີ້');
                                        return;
                                      }

                                      if (!isLessStocks && value >= order?.totalAmount) {
                                        errorSwal('ຈຳນວນສີນຄ້າຕ້ອງ ບໍ່ເກີນຈຳນວນໃນສະຕ໋ອກ');
                                        return;
                                      }

                                      updateOrder({
                                        product: order,
                                        productId: order?.product,
                                        indexCart: cIndex,
                                        indexOrder: oIndex,
                                        isAdded: false,
                                        changeValue: value,
                                      });

                                    }}
                                    value={order?.amount}
                                  />

                                </td>
                                <td align="center" style={{ padding: '1px 4px' }}>
                                  {((order?.children || []).some(c => String(c?.saleTag || "").toUpperCase() === "FREE")) ? null : (
                                    <Button
                                      style={{ fontSize: 12 }}
                                      onClick={() => { setUnitModalContext({ cartIndex: cIndex, orderIndex: oIndex }); handleOpenUnitModal(); }}
                                      size="small"
                                      variant="outline-success"
                                    >
                                      ເລືອກສິນຄ້າ
                                    </Button>
                                  )}
                                </td>
                                <td style={{ fontSize: 12 }}>
                                  {openEditPrice ? (
                                    <NumericFormat
                                      name="amount"
                                      min={0}
                                      className="form-control"
                                      style={{ width: 80, fontSize: 12 }}
                                      onChange={(e) =>
                                        handleEditPriceProduct(e, oIndex)
                                      }
                                      placeholder="ຈຳນວນສິນຄ້າ..."
                                      defaultValue={order?.price + convertCurrency(order?.currency)}
                                      thousandSeparator={true}
                                      prefix={""}
                                    />
                                  ) : (
                                    <p>
                                      {((order) => {
                                        if (!order) return "Loading..."; // Handle undefined order                  
                                        const basePrice = parseInt(order?.price || 0);
                                        const optionPrice = (order?.options || []).reduce(
                                          (acc, item) => acc + (item?.price || 0),
                                          0
                                        );

                                        return `${numberFormat(basePrice + optionPrice)}`;
                                      })(order)} {/* Pass order as argument */}
                                      {convertCurrency(order?.currency)}
                                    </p>
                                  )}
                                </td>
                                {/* <td style={{ fontSize: 12 }}>
                                  {numberFormat(order?.total ?? 0)}&ensp;
                                  {order?.currency === "USD"
                                    ? "$"
                                    : order?.currency === "BAHT"
                                      ? "฿"
                                      : order?.currency === "LAK"
                                        ? "₭"
                                        : ""}
                                </td> */}
                                <td style={{ fontSize: 12 }}>
                                  {numberFormat(order?.totalPrice ?? 0)}&ensp;
                                  {convertCurrency(order?.currency)}
                                </td>
                                <td style={{ padding: '1px 4px' }}>
                                  <CloseIcon
                                    onClick={() => onClearOrder(order, oIndex, cIndex)}
                                    sx={{
                                      cursor: "pointer",
                                      color: "#ff0000",
                                      fontSize: 18,
                                    }}
                                  />
                                </td>
                              </tr>
                              {order?.children && order?.children.map((child, childrenIndex) => {
                                const isFreeChild = String(child?.saleTag || child?.tag || "").toUpperCase() === "FREE";
                                return (
                                <tr key={childrenIndex.id}>
                                  <td className="ps-4" style={{ fontSize: 11 }}>
                                    {oIndex + 1}.{childrenIndex + 1}. {child?.productName}
                                    {isFreeChild && (
                                      <span style={{ marginLeft: 6, fontSize: 10, color: "#10B981", border: "1px solid #10B981", borderRadius: 10, padding: "0 6px" }}>ແຖມ</span>
                                    )}
                                  </td>
                                  <td style={{ fontSize: 11 }}>
                                    {child?._stock?.size ?? '-'}
                                    {child?._stock?.dimension?.length ? '(' + child?._stock?.dimension?.length + 'x' + child?._stock?.dimension?.width + 'x' + child?._stock?.dimension?.height + 'x' + child?._stock?.dimension?.weight + ')' : ''}
                                  </td>
                                  <td className="text-center" style={{ fontSize: 11 }} colSpan={2}>
                                    {isFreeChild ? (
                                      <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        value={child?.amount ?? 0}
                                        onChange={(e) =>
                                          handleUpdateChildAmount(childrenIndex, oIndex, cIndex, e.target.value)
                                        }
                                        style={{ fontSize: 11, textAlign: "center", padding: "2px 4px", height: 24 }}
                                      />
                                    ) : (
                                      child?.amount ?? child?.volume
                                    )}
                                  </td>
                                  {/* <td className="text-center" style={{ fontSize: 11 }}>x</td> */}
                                  {/* <td className="text-center" style={{ fontSize: 11 }}>{numberFormat(child?.price)}{convertCurrency(child?.currency)}</td> */}
                                  <td className="text-center" style={{ fontSize: 11 }}>
                                    {isFreeChild
                                      ? numberFormat(0)
                                      : numberFormat(child?.totalPrice)}
                                  </td>
                                  <td></td>
                                  <td className="text-center">
                                    <CloseIcon
                                      onClick={() => handleRemoveStockChildren(childrenIndex, oIndex, cIndex)}
                                      sx={{
                                        cursor: "pointer",
                                        color: "#ff0000",
                                        fontSize: 18,
                                      }}
                                    />
                                  </td>
                                </tr>
                                );
                              })}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </Table>

                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#A9B3BD",
                            paddingTop: 50
                          }}>
                          <EmptyProducts />
                          {/* <EmptyCart /> */}
                        </div>
                      </>
                    )}


                  </div>
                  <hr />
                  <div className="sale-cart-total-amout">
                    <div className="sale-cart-total">
                      <div
                        style={{
                          fontSize: 16,
                          paddingLeft: 10,
                        }}>
                        {t("totals_name")}
                      </div>
                      <div className="sale-cart-total-money">
                        <span style={{ fontWeight: "bold", fontSize: 16 }}>
                          {numberFormat(cart?.data?.orderGroup?.totalPrice ?? 0)}{" "}
                          ₭
                        </span>
                        <span style={{ fontWeight: "bold", fontSize: 16 }}>
                          {numberFormat(
                            cart?.data?.orderGroup?.sumPriceBaht ?? 0
                          )}{" "}
                          ฿
                        </span>
                        <span style={{ fontWeight: "bold", fontSize: 16 }}>
                          {numberFormat(cart?.data?.orderGroup?.sumPriceUsd ?? 0)}{" "}
                          $
                        </span>
                      </div>
                    </div>
                    {(
                      (cart?.data?.orderGroup?.discount ?? 0) > 0 ||
                      (cart?.data?.orderGroup?.discountManual ?? 0) > 0
                    ) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0px 10px 00px 20px",
                          fontSize: 16,
                        }}>
                        <span>
                          {t("discount_name")}
                        </span>
                        <span>
                          {(() => {
                            const manual = cart?.data?.orderGroup?.discountManual ?? 0;
                            const base = cart?.data?.orderGroup?.discount ?? 0;
                            if (manual > 0) {
                              const unit = cart?.data?.orderGroup?.discountType ? "₭" : "%";
                              return `${numberFormat(manual)} ${unit}`;
                            }
                            return `${numberFormat(base)} %`;
                          })()}
                        </span>
                      </div>
                    )}
                    {/* //* CASH */}
                    {cart?.data?.orderGroup?.cash > 0 &&
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0px 10px 00px 20px",
                          fontSize: 16,
                        }}>
                        <span> ເງີນສົດ </span>
                        <span>
                          {isNaN(cart?.data?.orderGroup?.cash) ? '0' : numberFormat(cart?.data?.orderGroup?.cash ?? 0)} ₭
                        </span>
                      </div>
                    }
                    {/* //* TRANSFER */}
                    {
                      cart?.data?.orderGroup?.transfer > 0 &&
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0px 10px 00px 20px",
                          fontSize: 16
                        }}
                      >
                        <span>ເງີນໂອນ</span>
                        <span>{isNaN(cart?.data?.orderGroup?.transfer) ? '0' : numberFormat(cart?.data?.orderGroup?.transfer)} ₭</span>
                      </div>
                    }
                    {/* //* DEBT */}
                    {
                      cart?.data?.orderGroup?.debt > 0 &&
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0px 10px 00px 20px",
                          fontSize: 16
                        }}
                      >
                        <span>ເງີນຕີດຫນີ້</span>
                        <span>{isNaN(cart?.data?.orderGroup?.debt) ? '0' : numberFormat(cart?.data?.orderGroup?.debt)} ₭</span>
                      </div>
                    }
                    {settingObject?.taxes?.taxStatus && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px 10px 00px 20px",
                            fontSize: 16,
                          }}>
                          <span>ລາຄາບໍ່ລວມອາກອນ</span>
                          <span>
                            {numberFormat(
                              cart?.data?.orderGroup?.taxes?.priceBeforeTax ??
                              ((cart?.data?.orderGroup?.sumPrice ?? 0) - (cart?.data?.orderGroup?.taxes?.taxAmount ?? 0))
                            )} ₭
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px 10px 00px 20px",
                            fontSize: 16,
                            fontWeight: "bold",
                          }}>
                          <span>
                            ອາກອນມູນຄ່າເພີ່ມ {settingObject?.taxes?.tax ?? 0}{settingObject?.taxes?.taxType === "PERCENT" ? "%" : "₭"}
                          </span>
                          <span>
                            {numberFormat(cart?.data?.orderGroup?.taxes?.taxAmount ?? 0)} ₭
                          </span>
                        </div>
                      </>
                    )}
                    <div
                      style={{
                        display: cart?.data?.orderGroup?.shippingCost > 0 ? "flex" : "none",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 10px 00px 20px",
                        fontSize: 16,
                      }}>
                      <span>
                        {cart?.data?.orderGroup?.costTitle}
                      </span>
                      <span>
                        {numberFormat(cart?.data?.orderGroup?.shippingCost ?? 0)}₭
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: 23,
                        padding: "0px 10px 00px 20px",
                        color: APP_COLOR,
                        fontWeight: "bold",
                      }}>
                      <span>
                        {t("sum_amount")}
                      </span>
                      {cart?.data?.orders?.length > 0 ? (
                        <span>
                          {numberFormat(cart?.data?.orderGroup?.sumPrice ?? 0)}{" "}
                          {cart?.orderGroup?.currency ??
                            convertCurrency(selectedPayCurrency)}
                        </span>
                      ) : (
                        <span>0</span>
                      )}
                    </div>
                    <div style={{ height: "17px" }}></div>

                    {/* ======== Button CheckBill ======== */}
                    <div
                      style={{
                        display: "flex",
                        paddingLeft: 15,
                        justifyContent: "center",
                      }}>
                      {editdata?.isEdited ?
                        <>
                          <CustomButton
                            width="40%"
                            title={t("cancel_btn_name")}
                            background="#f2f2f2"
                            color="#454545"
                            height={50}
                            icon={<ReactIcons.MdArrowBack />}
                            fontSize={16}
                            onClick={async () => {
                              await handleRemoveCart({
                                label: cart.label,
                                isRemove: true,
                              });
                              history.goBack();
                            }}
                            borderRadius="8px"
                          />

                          &ensp;

                          <CustomButton
                            width="100%"
                            title={t("edit_btn_name")}
                            background="green"
                            height={50}
                            icon={<FaCheck />}
                            fontSize={16}
                            onClick={async () => {
                              const selectedCart = cartDatas?.find(
                                (cart) => cart?.label === activeCart
                              );
                              if (selectedCart?.data?.orders?.length <= 0) return requiredSwal(t("required_info"))
                              handleOfferprices();
                            }}
                            borderRadius="8px"
                          />
                        </> :
                        <>

                          <CustomButton
                            width="100%"
                            title={t("pay_btn_name")}
                            background={LINEAR_GRADIENT_BG}
                            height={60}
                            icon={<FaCheckCircle />}
                            fontSize={16}
                            onClick={() => {
                              const selectedCart = cartDatas?.find(
                                (cart) => cart.label === activeCart
                              );
                              if (selectedCart?.data?.orders?.length <= 0) return requiredSwal(t("required_info"))
                              handleSaleModal();
                            }}
                            borderRadius="8px"
                          />
                        </>
                      }
                    </div>

                    {/* ======== end Button CheckBill ======== */}
                  </div>
                </div>
              </Tab>

            )

          })}
          {(cartDatas?.length < 3 && width > 700) && (
            <Tab
              style={{ borderBottom: "none", borderRadius: 'none', marginBottom: 0 }}
              title={
                <div
                  style={{
                    borderRadius: 5,
                    backgroundColor: "#fff",
                    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                    color: "#616161",
                    display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, fontSize: 12
                  }}
                  onClick={() => handleAddCart()}>
                  <Add style={{ fontSize: 16 }} />
                  New
                </div>
              }></Tab>
          )}
        </Tabs>


        {/* modal */}
        <CalculatorModal
          currentPoint={currentPoint}
          setCurrentPoint={setCurrentPoint}
          refetchUserConfirm={getuserConfirm}
          handleClearCartDatas={handleClearCartDatas}
          handleCreateOrderForPrintUsb={handleCreateOrderForPrintUsb}
          bill80Ref={bill80Ref}
          billA4Ref={billA4Ref}
          receivedMoney={receivedMoney}
          setReceivedMoney={setReceivedMoney}
          change={change}
          setChange={setChange}
          totalPricePay={totalPricePay}
          showDetailSaleModal={showDetailSaleModal}
          setShowDetailSaleModal={setShowDetailSaleModal}
          onCreateManyOrderWithOrderGroup={onCreateManyOrderWithOrderGroup}
          createOrderLoading={createOrderLoadingV4}
          loadingPrintBill={loadingPrintBill}
          loadingSaleBill={loadingSaleBill}
          saleOfferPriceLoading={saleOfferPriceLoading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onPrintBill={onPrintBill}
          selectedPayCurrency={selectedPayCurrency}
          setSelectedPayCurrency={setSelectedPayCurrency}
          setShowAddCusTomerBill={setShowAddCusTomerBill}
          setShowSelectCusTomer={setShowSelectCusTomer}
          customername={customername}
          createOrderPrintBill={createOrderPrintBill}
          createOrderNotPrintBill={createOrderNotPrintBill}
          onCreateManyOrderWithOrderGroupNotYetPaid={
            onCreateManyOrderWithOrderGroupNotYetPaid
          }
          onCreateManyOrderWithOrderGroupIndebTed={
            onCreateManyOrderWithOrderGroupIndebTed
          }
          createOrderNotYetPaidLoading={createOrderNotYetPaidLoading}
          createOrderIndebTedLoading={createOrderIndebTedLoading}
          setNotYetPaid={setNotYetPaid}
          setCartDatas={setCartDatas}
          cartDatas={cartDatas}
          serviceOther={serviceOther}
          setServiceOther={setServiceOther}
          activeCart={activeCart}
          handleOpentOfferprice={handleOpentOfferprice}
          shopData={shopData}
          setIsBillPrinting={setIsBillPrinting}
          promotionData={promotionData}
          _loadGenCode={_loadGenCode}
          userconfirmId={userconfirmId}
          channelName={channelName}
          channelTypes={channelTypes}
          handleChangeChannel={handleChangeChannel}
          convertChannelName={convertChannelName}
        />

        {/* modal IndebTed */}
        <Modal
          show={showaddcustomerIndebTed}
          centered
          onHide={() => {
            setShowAddCustomerIndebTed(false);
            localStorage.removeItem(PRINT_ORDER);
          }}
          size="lg">
          <Formik
            enableReinitialize={true}
            initialValues={{
              customerName: customername,
              phone: phonenumber,
              customerLastName: customerLastName,
              village: village,
              district: district,
              province: province,
              // shop: shopId,
            }}
            onSubmit={(values, { setSubmitting }) => {
              // onPrintBill();
              // onCreateManyOrderWithOrderGroupIndebTed();
              // console.log("submit");
              handlePrintA4();
              // setCustommerName("");
              // setPhoneNumber("");
            }}>
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
              <div className="p-3">
                <Modal.Body style={{ height: "auto" }}>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingTop: 5,
                      gap: 5,
                    }}>
                    <Form.Group className="w-100">
                      <Form.Label>ຊື່ລູກຄ້າ</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="......"
                        onChange={(e) => {
                          setSearchCustomer(e.target.value);
                        }}
                        value={searchcustomer}
                        className="w-100"
                      />
                    </Form.Group>
                    <div className="mt-4 pt-2">
                      <CustomButton
                        height={40}
                        width="130px"
                        borderRadius={8}
                        title="ເພີ່ມໃໜ່"
                        onClick={() => setShowAddCusTomerBill(true)}
                        icon={<ReactIcons.MdAdd style={{ fontSize: 28 }} />}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      height: "400px",
                      overflow: "auto",
                      marginTop: "1em",
                    }}>
                    {customerList?.length > 0 ? (
                      <Table hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>ຊື່ລູກຄ້າ</th>
                            <th>ເບີໂທ</th>
                            <th>ບ້ານ</th>
                            <th>ເມືອງ</th>
                            <th>ເເຂວງ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerList?.map((u, index) => (
                            <tr
                              key={"userconfirm" + index}
                              style={{
                                background:
                                  selectuserconfirm?.id === u?.id
                                    ? "#ddd"
                                    : "",
                                cursor: "pointer",
                                color:
                                  selectuserconfirm?.id === u?.id ? "red" : "",
                              }}
                              onClick={() => {
                                setSelectUserConfirm(u);
                                localStorage.setItem(PRINT_ORDER, JSON.stringify({ status: "INDEBTED" }));
                              }}>
                              {selectuserconfirm?.id === u?.id ? <td><ReactIcons.FaCheck style={{ color: 'green' }} /> </td> : <td>{index + 1}</td>}
                              <td>{u?.name}</td>
                              <td>{u?.phone}</td>
                              <td>{u?.address?.village}</td>
                              <td>{u?.address?.district}</td>
                              <td>{u?.address?.province}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      "Empty Customer"
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                  <Form.Group className="mb-5 w-50" controlId="exampleForm.ControlInput1">
                    <Form.Label>ກຳນົດວັນທີຈ່າຍເງິນລູກຄ້າ</Form.Label>
                    <Form.Control type="date" onChange={(e) => setPaymentDate(e?.target?.value)} value={paymentDate} />
                  </Form.Group>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "end", gap: 5
                    }}>
                    {editdata?.isEdited && (
                      <div
                        style={{
                          display: "flex",
                          fontWeight: "bold",
                          padding: "2px",
                          alignItems: "center",
                          color: "#3C169B",
                        }}>
                        <div>
                          <span>ຊື່ລູກຄ້າ : {selectuserconfirm ?? values.customerName}</span>&emsp;
                          <span>ເບີໂທ : {values.phone}</span>
                        </div>
                      </div>
                    )}

                    <CustomButton
                      width="100%"
                      height={42}
                      borderRadius={4}
                      background="transparent"
                      color="#3C169B"
                      border="1px solid #3C169B "
                      fontweight={400}
                      title={"ຍົກເລີກ"}
                      disabled={createOrderIndebTedLoading}
                      onClick={() => {
                        localStorage.removeItem(PRINT_ORDER);
                        if (editdata?.isEdited) {
                          setShowAddCustomerIndebTed(false)
                        } else {
                          setCustommerName();
                          setPhoneNumber();
                          setCustommerLastName();
                          setVillage();
                          setDistrict();
                          setProvince();
                          setSelectUserConfirm();
                          setShowAddCustomerIndebTed(false);
                        }
                      }}
                    />
                    <CustomButton
                      width="100%"
                      height={42}
                      background={!selectuserconfirm ? COLOR_WHITE_200 : LINEAR_GRADIENT_BG}
                      disabled={(selectuserconfirm ?? createOrderIndebTedLoading) ? false : true}
                      borderRadius={4}
                      title={"ບໍ່ຮັບບິນ"}
                      type="button"
                      onClick={() => onCreateManyOrderWithOrderGroupIndebTed()}
                      icon={<ReactIcons.TbPrinterOff />}
                    />

                    <div className="w-100">
                      <CustomButton
                        width="100%"
                        height={42}
                        background={!selectuserconfirm ? COLOR_WHITE_200 : LINEAR_GRADIENT_BG}
                        disabled={(selectuserconfirm ?? createOrderIndebTedLoading) ? false : true}
                        borderRadius={4}
                        icon={<ReactIcons.BsFillPrinterFill />}
                        title={createOrderIndebTedLoading ? t("creating_order") : (previewingA4 ? t("preview_printing") : t("get_bill_a4"))}
                        onClick={handleSubmit}
                      />
                      <ReactToPrint
                        ref={currentBillA4Ref}
                        content={() => {
                          return billA4Ref.current;
                        }}
                        onAfterPrint={() => {
                          setPreviewingA4(false);
                          localStorage.removeItem(PRINT_ORDER);
                          onCreateManyOrderWithOrderGroupIndebTed();
                        }}
                      />
                    </div>
                  </div>
                </Modal.Footer>
              </div>
            )}
          </Formik>
        </Modal>

        {/* Bill 50mm */}
        <div style={{ width: "58mm", display: "none" }} ref={bill58Ref}>
          <BillForCheckOut58
            showDetailSaleModal={showDetailSaleModal}
            receivedMoney={receivedMoney}
            cartDatas={cartDatas}
            activeCart={activeCart}
          />
        </div>

        {/* Bill 80mm */}
        <div style={{ minWidth: "80mm", maxWidth: "80mm", width: "80mm" }} ref={bill80Ref} inert="true">
          <BillForCheckOut80
            showDetailSaleModal={showDetailSaleModal}
            receivedMoney={receivedMoney}
            cartDatas={cartDatas}
            activeCart={activeCart}
            selectedPayCurrency={selectedPayCurrency}
            gencodeordergroup={gencodeordergroup}
            customername={customername}
            phonenumber={phonenumber}
            userconfirmName={userconfirmName}
            userconfirmPhone={userconfirmPhone}
            bankaccount={bankaccount}
            customerLastName={customerLastName}
            village={village}
            district={district}
            province={province}
            notYetPaid={notYetPaid}
            prepareRate={prepareRate}
            shopData={shopDataNow}
            isBillNumber={isBillNumber}
            activeTab={activeTab}
            base64Image={base64Image}
            change={change}
          />
        </div>

        {/* Bill A4 */}
        <div style={{ width: "100%", padding: "1em", background: "#fff" }} ref={billA4Ref} inert="true">
          <BillForCheckOutA4V2
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
              selectedPayCurrency={selectedPayCurrency}
              gencodeordergroup={gencodeordergroup}
              customername={customername}
              phonenumber={phonenumber}
              userconfirmName={userconfirmName}
              userconfirmPhone={userconfirmPhone}
              bankaccount={bankaccount}
              customerLastName={customerLastName}
              village={village}
              district={district}
              province={province}
              notYetPaid={notYetPaid}
              prepareRate={prepareRate}
              shopData={shopDataNow}
              isBillNumber={isBillNumber}
              activeTab={activeTab}
              base64Image={base64Image}
              change={change}
            />
          {/* {isA4V3Shop ? (
            <BillForCheckOutA4V3
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
              selectedPayCurrency={selectedPayCurrency}
              gencodeordergroup={gencodeordergroup}
              customername={customername}
              phonenumber={phonenumber}
              userconfirmName={userconfirmName}
              userconfirmPhone={userconfirmPhone}
              bankaccount={bankaccount}
              customerLastName={customerLastName}
              village={village}
              district={district}
              province={province}
              notYetPaid={notYetPaid}
              prepareRate={prepareRate}
              shopData={shopDataNow}
              isBillNumber={isBillNumber}
              activeTab={activeTab}
              base64Image={base64Image}
              change={change}
            />
          ) : (
            <BillForCheckOutA4V2
              showDetailSaleModal={showDetailSaleModal}
              receivedMoney={receivedMoney}
              cartDatas={cartDatas}
              activeCart={activeCart}
              selectedPayCurrency={selectedPayCurrency}
              gencodeordergroup={gencodeordergroup}
              customername={customername}
              phonenumber={phonenumber}
              userconfirmName={userconfirmName}
              userconfirmPhone={userconfirmPhone}
              bankaccount={bankaccount}
              customerLastName={customerLastName}
              village={village}
              district={district}
              province={province}
              notYetPaid={notYetPaid}
              prepareRate={prepareRate}
              shopData={shopDataNow}
              isBillNumber={isBillNumber}
              activeTab={activeTab}
              base64Image={base64Image}
              change={change}
            />
          )} */}
        </div>
      </div>

      <Modal show={showUnitModal} onHide={() => setShowUnitModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>ເລືອກຫົວໜ່ວຍສິນຄ້າ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!selectedUnitName && unitOptions.length === 0 ? (
            <div style={{ padding: 8 }}>ບໍ່ພົບຫົວໜ່ວຍໃນສິນຄ້າ</div>
          ) : !selectedUnitName ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}>
              {unitOptions.map((u) => (
                <Button key={u} variant="outline-primary" onClick={() => handleSelectUnit(u)}>
                  {u}
                </Button>
              ))}
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: "bold" }}>ຫົວໜ່ວຍ: {selectedUnitName}</span>
                <Button variant="outline-secondary" size="sm" onClick={handleClearUnitFilter}>ກັບໄປເລືອກຫົວໜ່ວຍ</Button>
              </div>
              {unitFilteredProducts.length === 0 ? (
                <div style={{ padding: 8 }}>ບໍ່ພົບສິນຄ້າໃນຫົວໜ່ວຍນີ້</div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}>
                  {unitFilteredProducts.map((p) => (
                    <Button key={p?.id} variant="light" onClick={() => handleAddFreeChild(p)}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                        <span style={{ fontSize: 12, fontWeight: "bold" }}>{p?.name}</span>
                        <span style={{ fontSize: 11, color: "#6B7280" }}>
                          {p?.unitId?.name ?? p?.unit}
                          {p?.size ? ` • ${p.size}` : ""}
                        </span>
                      </div>
                    </Button>
                  ))}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUnitModal(false)}>ປິດ</Button>
          {!selectedUnitName && <Button variant="outline-danger" onClick={handleClearUnitFilter}>ສະແດງທັງໝົດ</Button>}
        </Modal.Footer>
      </Modal>

      {/* ฺBill Offerpirce */}
      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          <BillOfferPrice
            showDetailSaleModal={showDetailSaleModal}
            receivedMoney={receivedMoney}
            cartDatas={cartDatas}
            activeCart={activeCart}
            offerPrice={offerPrice}
            codeBill={codeBill}
            customername={customername}
            customerLastName={customerLastName}
            phonenumber={phonenumber}
            village={village}
            district={district}
            province={province}
          />
        </div>
      </div>



      {/* Bill for Indebted */}
      <div style={{ display: "none" }}>
        <div ref={billIndebTedRef}>
          <BillIndebTed
            showDetailSaleModal={showDetailSaleModal}
            receivedMoney={receivedMoney}
            cartDatas={cartDatas}
            activeCart={activeCart}
            selectedPayCurrency={selectedPayCurrency}
            gencodeordergroup={gencodeordergroup}
            customername={customername}
            phonenumber={phonenumber}
            userconfirmName={userconfirmName}
            userconfirmPhone={userconfirmPhone}
            bankaccount={bankList}
            customerLastName={customerLastName}
            village={village}
            district={district}
            province={province}
            notYetPaid={notYetPaid}
          />
        </div>
      </div>

      {/* modal custom customer screen */}
      <Modal
        show={isCustomerScreen?.isOpen}
        keyboard={false}>
        <Modal.Header style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, textAlign: 'center' }} >
          <Modal.Title>ຕັ້ງຄ່າຈໍເບື້ອງລູກຄ້າ</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "4em" }}>
          <SettingCmScreen onCloseModal={() => setIsCustomerScreen({ isOpen: false })} />
        </Modal.Body>
      </Modal>

      {/* Modal Select Customer */}
      <Modal
        show={showSelectCustomer}
        centered
        onHide={() => setShowSelectCusTomer(false)}
        backdrop="static"
        keyboard={false}
        size="lg">
        <Modal.Body style={{ padding: "3em" }}>

          <div className="d-flex justify-content-between">
            <h2
              style={{
                fontSize: 24,
                fontWeight: "bold",
                paddingBottom: 15
              }}>
              ຂໍ້ມູນລູກຄ້າ
            </h2>
            <CustomButton
              height={40}
              width={80}
              borderRadius={8}
              title="ເພິ່ມ"
              onClick={() => setShowAddCusTomerBill(true)}
              icon={<ReactIcons.MdAdd />}
            />
          </div>
          <div className="d-flex gap-2">
            <Form.Group className="w-100">
              <Form.Label>ຊື່ລູກຄ້າ</Form.Label>
              <Form.Control
                placeholder="ຄົ້ນຫາ...."
                onChange={(e) => {
                  setIsSearch(e.target.value);
                }}
                onKeyDown={handleKeyDown}
                value={isSearch}

              />
            </Form.Group>
            <div style={{ flex: 1 }}>
              {getUserTypeLoading || _.isEmpty(newUserTypeData) ? "loading" :
                <Form.Group style={{ width: 200 }}>
                  <Form.Label>ປະເພດລູກຄ້າ</Form.Label>
                  <Form.Select
                    name="userType"
                    onChange={(e) => setSelectUserType(e.target.value)}
                    value={selectUserType}
                    aria-label="Default select example">
                    <option value="">
                      --ເລືອກ--
                    </option>
                    {newUserTypeData.map((i) => (
                      <option key={i?.id} value={i?.id}>
                        {i?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              }
            </div>
          </div>
          <div style={{ height: "27em", overflow: "auto", marginTop: "1em" }}>
            {(customerList?.length > 0) ? (
              <Table hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ຊື່ລູກຄ້າ</th>
                    <th>ເບີໂທ</th>
                    <th>ບ້ານ</th>
                    <th>ເມືອງ</th>
                    <th>ເເຂວງ</th>
                    <th>ປະເພດ</th>
                  </tr>
                </thead>
                <tbody>
                  {customerList?.map((u, index) => (
                    <tr
                      key={"userconfirm2" + index}
                      style={{
                        color: selectuserconfirm?.id === u?.id ? "green" : "",
                        cursor: "pointer",
                        fontWeight:
                          selectuserconfirm?.id === u?.id ? "bold" : "",
                      }}
                      onClick={() => {
                        setSelectUserConfirm(u);
                      }}>
                      <td>{index + 1}</td>
                      <td>{u?.name}</td>
                      <td>{u?.phone}</td>
                      <td>{u?.address?.village}</td>
                      <td>{u?.address?.district}</td>
                      <td>{u?.address?.province}</td>
                      <td>{u?.userType?.name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                }}>
                <EmptyComponent />
                <p>{userconfirmLoading ? "ກຳລັງໂຫລດຂໍ້ມູນ..." : "ຍັງບໍ່ມີລູກຄ້າກະລຸນາໄປເພີ່ມລູກຄ້າກ່ອນ... !!!"}</p>
              </div>
            )}

          </div>


        </Modal.Body>
        <Modal.Footer className="d-flex gap-2 justify-content-between align-items-center">
          <p>ຊື່: {selectuserconfirm?.name ?? "................."}, ເບີໂທ: {selectuserconfirm?.phone ?? "................."}</p>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <CustomButton
              width={140}
              height={42}
              borderRadius={4}
              background="transparent"
              color="#3C169B"
              border="1px solid #3C169B "
              fontweight={400}
              title={"ຍົກເລີກ"}
              onClick={() => {
                setCustommerName();
                setPhoneNumber();
                setSelectUserConfirm();
                setShowSelectCusTomer(false);
                setVillage();
                setDistrict();
                setProvince();
                setCustommerLastName();
              }}
            />
            &emsp;
            {!selectuserconfirm ? (
              ""
            ) : (
              <CustomButton
                width={140}
                height={42}
                background="#1F3A60"
                borderRadius={4}
                title={"ຢືນຢັນ"}
                onClick={() => {
                  setShowSelectCusTomer(false);
                }}
              />
            )}
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal Add Customer */}
      <Modal
        show={showAddCustomerBill}
        centered
        onHide={() => handleConfirmClose}
        size="lg">
        <Formik
          initialValues={{
            name: "",
            lastname: "",
            gender: "male",
            phone: "",
            address: {
              village: "",
              province: "",
              district: "",
            },
            shop: shopId,
            userType: ""
          }}
          onSubmit={(values, { setSubmitting }) => {
            _createUser(values);
          }}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <Modal.Body>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#3C169B",
                  }}>
                  ເພີ່ມລູກຄ້າໃໝ່
                </div>
                <div style={{ padding: "4em", height: '38em' }}>
                  <Form>
                    <div className="d-flex justify-content-between align-items-center gap-4">
                      <Form.Group
                        className="mb-3 w-100"
                        controlId="formGroupEmail">
                        <Form.Label>ຊື່</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                          placeholder="ປ້ອນຊື່..."
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3 w-100"
                        controlId="formGroupEmail">
                        <Form.Label>ນາມສະກຸນ</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastname"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastname}
                          placeholder="ປ້ອນນາມສະກຸນ..."
                        />
                      </Form.Group>
                    </div>
                    <Row>
                      <Col>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3" controlId="formGroupEmail">
                              <Form.Label>ເພດ</Form.Label>
                              <Form.Select
                                defaultValue="Choose..."
                                name="gender"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.gender}
                                aria-label="Default select example">
                                <option>--ເລືອກ--</option>
                                <option value="male">ຊາຍ</option>
                                <option value="female">ຍິງ</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3" controlId="formGroupPassword">
                              <Form.Label>ເບີໂທລູກຄ້າ</Form.Label>
                              <Form.Control
                                type="tel"
                                name="phone"
                                inputMode="numeric"
                                maxLength={8}
                                pattern="[0-9]{8}"
                                value={phonenumberAdd}
                                onChange={(e) => setPhoneNumberAdd(e?.target.value)}
                                onBlur={handleBlur}
                                placeholder="ປ້ອນເບີໂທ..."
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label>ປະເພດລູກຄ້າ</Form.Label>
                          {getUserTypeLoading || _.isEmpty(newUserTypeData) ? (
                            <p>ບໍ່ພົບຂໍ້ມູນປະເພດລູກຄ້າ...</p>
                          ) : (
                            <Form.Select
                              name="userType"
                              onChange={(e) => setAddUserType(e.target.value)}
                              onBlur={handleBlur}
                              value={addUserType}
                              required
                              aria-label="Default select example"
                            >
                              {newUserTypeData.map((i) => (
                                <option key={i?.id} value={i?.id}>
                                  {i?.name}
                                </option>
                              ))}
                            </Form.Select>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div
                      style={{
                        marginBottom: 5,
                        opacity: 0.7
                      }}>
                      ຂໍ້ມູນທີ່ຢູ່
                    </div>

                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formGroupPassword">
                          <Form.Label>ແຂວງ</Form.Label>
                          <Form.Select
                            name="address.province"
                            onChange={(e) => {
                              setSelectProvince(e.target.value);
                            }}
                            onBlur={handleBlur}
                            value={selectProvince}
                            aria-label="Default select example">
                            <option value="">--ເລືອກ--</option>
                            {LaoAddress.map((p, index) => (
                              <option
                                key={"province" + index}
                                value={p?.province_name}>
                                {p?.province_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formGroupPassword">
                          <Form.Label>ເມືອງ</Form.Label>
                          <Form.Select
                            name="address.district"
                            disabled={!selectProvince}
                            onChange={(e) => {
                              setSelectDistrict(e.target.value);
                            }}
                            onBlur={handleBlur}
                            value={selectDistrict}
                            aria-label="Default select example">
                            <option value="">--ເລືອກ--</option>
                            {selectProvince &&
                              LaoAddress.filter(
                                (f) => f.province_name === selectProvince
                              )[0].district_list.map((p, index) => (
                                <option
                                  key={"district" + index}
                                  value={p?.district}>
                                  {p?.district}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Form.Label>ບ້ານຢູ່ປັດຈຸບັນ</Form.Label>
                        <Form.Group className="mb-3" controlId="formGroupPassword">
                          <Form.Control
                            type="text"
                            name="address.village"
                            onChange={(e) => {
                              setSelectVillage(e.target.value);
                            }}
                            onBlur={handleBlur}
                            value={selectvillage}
                            placeholder="ປ້ອນຊື່ບ້ານ..."
                          />
                        </Form.Group>
                      </Col>

                    </Row>
                  </Form>
                </div>
              </Modal.Body>
              <Modal.Footer style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}>
                  <div>
                    <CustomButton
                      width={140}
                      height={42}
                      borderRadius={4}
                      background="transparent"
                      color={APP_COLOR}
                      border={`1px solid ${APP_COLOR}`}
                      fontweight={400}
                      title={"ຍົກເລີກ"}
                      onClick={() => {
                        setSelectDistrict();
                        setSelectProvince();
                        setSelectVillage();
                        setVillage();
                        setDistrict();
                        setProvince();
                        setCustommerLastName();
                        setShowAdddress(false);
                        handleConfirmClose();
                      }}
                    />
                  </div>
                  &emsp;
                  <div>
                    <CustomButton
                      width={140}
                      height={42}
                      background={LINEAR_GRADIENT_BG}
                      borderRadius={4}
                      title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                      onClick={() => handleSubmit()}
                    />
                  </div>
                </div>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>

      {/* Modal Edit Debt */}
      <Modal
        show={showAddcustommer}
        centered
        onHide={() => setShowAddCustommer(false)}
        size="lg"
      >
        <Formik
          enableReinitialize={true}
          initialValues={{
            customerName: customername,
            phone: phonenumber,
            customerLastName: customerLastName,
            village: village,
            district: district,
            province: province,
            shop: shopId,
          }}
          onSubmit={(values, { setSubmitting }) => {
            if (editdata?.isFromSale === true || editdata?.indebted === true) _updateorders();
          }}
        >
          {({
            values,
            handleSubmit,
          }) => (
            <>
              <Modal.Body style={{ height: "550px", padding: 20 }}>
                {orderGroupV2Loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <AnimationLoading />
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        padding: "5px",
                        fontSize: "24px",
                        fontWeight: "700",
                      }}
                    >
                      ເລືອກຊື່ລູກຄ້າ
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "20px",
                        gap: 20,
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <Form.Control
                          type="text"
                          placeholder="ຄົ້ນຫາຊື່ ຫຼື ເບີໂທ..."
                          onChange={(e) => {
                            setSearchCustomer(e.target.value);
                          }}
                          value={searchcustomer}
                        />
                      </div>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <CustomButton
                          height={40}
                          borderRadius={8}
                          title={"ເພິ່ມ"}
                          onClick={() => setShowAddCusTomerBill(true)}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        height: "400px",
                        overflow: "auto",
                        marginTop: "1em",
                      }}
                    >
                      {customerList?.length > 0 ? (
                        <Table hover>
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>ຊື່ລູກຄ້າ</th>
                              <th>ເບີໂທ</th>
                              <th>ບ້ານ</th>
                              <th>ເມືອງ</th>
                              <th>ເເຂວງ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {customerList?.map((u, index) => (
                              <tr
                                key={"userconfirm1" + index}
                                style={{
                                  // background:
                                  // selectuserconfirm?.id === u?.id
                                  //   ? "aqua"
                                  //   : "",
                                  cursor: "pointer",
                                  color:
                                    selectuserconfirm?.id === u?.id
                                      ? "green"
                                      : "",
                                }}
                                onClick={() => {
                                  setSelectUserConfirm(u);
                                }}
                              >
                                <td>{index + 1}</td>
                                <td>{u?.name}</td>
                                <td>{u?.phone}</td>
                                <td>{u?.address?.village}</td>
                                <td>{u?.address?.district}</td>
                                <td>{u?.address?.province}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        "Empty Customer"
                      )}
                    </div>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: editdata?.isEdited
                      ? "space-between"
                      : "center",
                    width: "100%",
                  }}
                >
                  {editdata?.isEdited ? (
                    <div
                      style={{
                        display: "flex",
                        fontWeight: "bold",
                        padding: "2px",
                        alignItems: "center",
                        color: "#3C169B",
                      }}
                    >
                      <div>
                        <span>ຊື່ລູກຄ້າ : {values.customerName}</span>&emsp;
                        <span>ເບີໂທ : {values.phone}</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="d-flex justify-content-center gap-8">
                    {editdata?.isEdited ? (
                      <CustomButton
                        width={200}
                        height={60}
                        borderRadius={4}
                        background="transparent"
                        color="#3C169B"
                        border="1px solid #3C169B "
                        fontweight={400}
                        title={"ຍົກເລີກ"}
                        onClick={() => setShowAddCustommer(false)}
                      />
                    ) : (
                      <CustomButton
                        width={200}
                        height={60}
                        borderRadius={4}
                        background="transparent"
                        color="#3C169B"
                        border="1px solid #3C169B "
                        fontweight={400}
                        title={"ຍົກເລີກ"}
                        onClick={() => {
                          setCustommerName();
                          setPhoneNumber();
                          setCustommerLastName();
                          setVillage();
                          setDistrict();
                          setProvince();
                          setSelectUserConfirm();
                          setShowAddCustommer(false);
                        }}
                      />
                    )}
                    &emsp;
                    {editdata?.isEditedSale === true || editdata?.isEdited ? (
                      <CustomButton
                        width={200}
                        height={60}
                        background="#1F3A60"
                        borderRadius={4}
                        title={"OK"}
                        onClick={() => handleSubmit()}
                      />
                    ) : (
                      <div onClick={async () => await handleSubmit()}>
                        <ReactToPrint
                          pageStyle={getPageSize}
                          trigger={() => (
                            <CustomButton
                              width={200}
                              height={60}
                              background="#1F3A60"
                              borderRadius={4}
                              title={"OK"}
                            />
                          )}
                          content={() =>
                            values.customerName &&
                            values.phone &&
                            componentRef.current
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>

      {/* modal comfirm edit price in cart */}
      <ComfirmModal
        showConfirmModal={showConfirmRemove}
        handleCancel={handleCloseRemoveProduct}
        handleConfirm={handleConfirmRemoveCart}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການແກ້ໄຂ ລາຄາ ໃນກະຕ່າບໍ?"
      />
      {paymentQR &&
        <WaitingPaymentModal
          show={paymentQR ? true : false}
          paymentData={paymentQR}
          showClose={true}
          onHide={() => {
            localStorage.removeItem("PAYMENT_QR_DATA");
            setPaymentQR(null);
          }}
          receivedMoney={receivedMoney}
          viewCurrency={viewCurrency}
        />
      }
    </>
  );
}
export default Carts;
